
import { Vue, Component, Watch, Prop, Model } from 'vue-property-decorator'
import * as d3 from '../ts/d3'
import _ from 'lodash'
import { flextree } from 'd3-flextree'
import moment from 'moment'
import ImData from '../ts/ImData'
import History from '../ts/History'
import toMarkdown from '../ts/toMarkdown'
import WzTxtEditorMind from './WzTxtEditor.vue' // editor de text tynimce
moment.locale('fr')

Vue.component('wz-txt-editor-mind', WzTxtEditorMind) // editeur de text

let mmdata: ImData // le json
@Component({
  components: {}
})
export default class MindMap extends Vue {
  @Prop() width: number | undefined
  @Prop() height: number | undefined
  @Prop({ default: 50 }) xSpacing!: number
  @Prop({ default: 40 }) ySpacing!: number
  @Prop({ default: true }) autoScale!: boolean
  @Prop({ default: true }) draggable!: boolean
  @Prop({ default: true }) gps!: boolean
  @Prop({ default: true }) fitView!: boolean
  @Prop({ default: true }) download!: boolean
  @Prop({ default: true }) keyboard!: boolean
  @Prop({ default: true }) showNodeAdd!: boolean
  @Prop({ default: true }) showNodeExpand!: boolean
  @Prop({ default: true }) contextMenu!: boolean
  @Prop({ default: true }) zoomable!: boolean
  @Prop({ default: true }) showUndo!: boolean
  @Prop({ default: false }) brideEdition!: boolean
  @Prop({ default: 2 }) strokeWidth!: number
  @Prop({ default: 350 }) textWidth!: number
  @Prop({ default: 6 }) gPointSize!: number
  @Prop({ default: '' }) botWorkspace!: string
  @Prop({ default: '' }) listJumpto!: string
  @Model('change', { required: true }) value!: Array<Data>

  @Watch('keyboard')
  onKeyboardChanged(val: boolean) { this.makeKeyboard(val) }
  @Watch('showNodeAdd')
  onShowNodeAddChanged(val: boolean) { this.makeNodeAdd(val) }
  @Watch('draggable')
  onDraggableChanged(val: boolean) {
    this.makeDrag(val)
    console.log('dragable')
  }
  @Watch('contextMenu')
  onContextMenuChanged(val: boolean) { this.makeContextMenu(val) }
  @Watch('xSpacing')
  onXSpacingChanged() {
    mmdata.resize()
    this.updateMmdata()
    this.updateMindmap()
  }
  @Watch('ySpacing')
  onYSpacingChanged() {
    this.updateMindmap()
  }

  @Watch('zoomable')
  onZoomableChanged(val: boolean) { this.makeZoom(val) }

  $refs!: {
    mindmap: HTMLDivElement
    svg: Element
    content: Element
    dummy: HTMLDivElement
    menu: HTMLDivElement
    selectedBox: SVGRectElement
    form: any
  }
  loading:boolean = false
  snackBarVisible:Boolean = false
  snackBarText:String = 'test text snackbar'
  snackBarColor:String = 'info'
  // data formulaire
  switchDossier = false
  switchTechnique = false
  switchJumpTo = false
  errorMessages = ''
  selectNodeCoords:any[] = []
  dragFlag = false
  zoomNum = 0.5
  zoomSelect = 0
  multiSeleFlag = false
  minTextWidth = 6
  minTextHeight = 21
  gBtnInfosSize = 20
  gBtnAddSize = 16
  spaceNodePoint = 20
  widthJuptoText = 180
  decalageNode0 = 0
  decalageNodeCascadeY = 0 // pour décalé vers le bas
  foreignBorderWidth = 3
  spaceKey = false
  toRecord = true
  toUpdate = true
  dTop!: FlexNode
  root!: FlexNode
  showContextMenu = false
  showPopUps = false
  showPopUpOption = false
  showPopUpLongText = false
  showPopUpIndos = false
  showPopUpValidDel = false
  showPopUpValidDel2 = false
  showSelectedBox = false
  contextMenuX = 0
  contextMenuY = 0
  xforms = null
  editeMap:boolean = false
  editOptionNum:Number = -1
  editTxtNum:Number = -1
  editJumpNum:Number = -1
  editTitleNum:Number = -1
  cloneFlexNode!: FlexNode
  selectMenuNode!: FlexNode
  mouse = { x0: 0, y0: 0, x1: 0, y1: 0 }
  contextMenuTarget!: Mdata | Mdata[]
  contextMenuItems = [
    { title: 'Infos', name: 'infos', disabled: false, icone: 'info' },
    { title: 'Collapse', name: 'réduire', disabled: false, icone: 'call_merge', class: 'iconeRotate-90'  },
    { title: 'Expand', name: 'étendre', disabled: false, icone: 'call_split', class: 'iconeRotate90'  },
    /*{ title: 'Delete', name: 'éffacer', disabled: false, icone: 'delete'  }*/
  ]
  optionList = [
    { title: 'JSON', icon: 'code', tip: 'Save JSON format', color: 'purpleOpt' },
    { title: 'Pict', icon: 'image', tip: 'Save jpeg format', color: 'greenOpt', disabled: true },
    { title: 'Markdown', icon: 'grading', tip: 'Save MarkDown format', color: 'grassOpt' }
  ]
  selectNodeInfos:any = {
      dialog_node: '',
      title: '',
      conditions: '',
      cascade: 0,
      next_step: '',
      output: {
        generic: '',
        targetfirst: ''
      }
    }
  nodeToDel = {
      dialog_node: '',
      id: '',
      parent: '',
      conditions: '',
      title: ''
    }
  newitem = {
    label: ''
  }
  treeOpen:any = []
  arboNodes:any = []
  arrayAllNodes:any = []
  newJumpTo:any = []
  newTransfert = ''
  infosJumpTo:any
  listTransfert = [
    {text: 'Vers discussion chat (si agent disponible)', value: 'chat'},
    {text: 'Vers formulaire', value: 'form'},
    {text: 'Vers callback (si option souscrite)', value: 'c2c'},
    {text: 'Vers meeting (si option souscrite)', value: 'meeting'}
  ]
  branchToDel = {
    label: '',
    value: {
      input: {
        text: ''
      }
    },
    dialog_node: ''
  }
  editorToggleHTML = false
  branchesToDelete:any[] = []
  editNewContentChatbot = false
  editNewOption = false
  editNewJumpTo = false
  editNewTransfert = false
  selectNodeInfosOptions:any[] = []
  nodeInfosOptions:any[] = []
  selectedOption = 0
  mindmapSvg!: d3.Selection<Element, FlexNode, null, undefined>
  mindmapG!: d3.Selection<Element, FlexNode, null, undefined>
  dummy!: d3.Selection<HTMLDivElement, FlexNode, null, undefined>
  mindmapSvgZoom!: d3.ZoomBehavior<Element, FlexNode>
  easePolyInOut = d3.transition().duration(1000).ease(d3.easePolyInOut)
  link = d3.linkHorizontal().x((d) => d[0]).y((d) => d[1])
  linkJumpTo = d3.linkVertical().x((d) => d[0]).y((d) => d[1])
  zoom = d3.zoom() as d3.ZoomBehavior<Element, FlexNode>
  history = new History()
  saveData = false
  maxlengthOption:Number = 128
  maxlengthTitle:Number = 512

  get mmStyle() {
    return {
      width: this.width ? `${this.width}px` : '100%',
      height: this.height ? `${this.height}px` : '',
    }
  }
  get svgClass() { return `stroke-width-${this.strokeWidth} ${this.spaceKey && this.zoomable ? 'grab' : ''} ${this.editeMap ? 'tf_grid' : ''}` }
  get optionTip() { return this.optionList[this.selectedOption].tip }
  get canUndo() { return this.history.canUndo }
  get canRedo() { return this.history.canRedo }
  get seleBox() {
    const { x0, x1, y0, y1 } = this.mouse
    const x = Math.min(x0, x1)
    const y = Math.min(y0, y1)
    const width = Math.abs(x0 - x1)
    const height = Math.abs(y0 - y1)
    return { x, y, width, height, left: x, top: y, right: x + width, bottom: y + height }
  }

  modifOption(data: any) {
    // console.log('modifOption', data)
    this.editOptionNum = data.option
    // ferme les autres
    this.editTxtNum = -1
    this.editTitleNum = -1
    this.editJumpNum = -1
  }
  modifTxt(data: any) {
    this.editTxtNum = data.nodeIndex
    // ferme les autres
    this.editOptionNum = -1
    this.editTitleNum = -1
    this.editJumpNum = -1
  }
  modifTitle(data: any) {
    this.editTitleNum = data.nodeIndex
    // ferme les autres
    this.editOptionNum = -1
    this.editTxtNum = -1
    this.editJumpNum = -1
  }
  modifJump(num: number) {
    this.editJumpNum = num
    // ferme les autres
    this.editOptionNum = -1
    this.editTitleNum = -1
    this.editTxtNum = -1
  }

  getViewPos(p?: DOMRect) {
    const svgPos = this.$refs.svg.getBoundingClientRect()
    const { pageX, pageY } = d3.event
    const viewLeft = svgPos.left + window.pageXOffset
    const viewTop = svgPos.top + window.pageYOffset
    const { left, top, right, bottom } = p || { left: pageX, top: pageY, right: pageX, bottom: pageY }
    // const div = this.$refs.mindmap
    // let rect = (this.$refs.content as SVGGElement).getBBox()

    return {
      left: left - viewLeft,
      top: top - viewTop,
      right: right,
      bottom: bottom,
      // width: div.offsetWidth,
      // height: div.offsetHeight,
      // rect: rect
    }
  }
  updateMmdata(val?: Mdata | null) {
    // console.log('updateMmdata val', val)
    // console.log('updateMmdata mmdata', mmdata)
    if (val) {
      mmdata.data = JSON.parse(JSON.stringify(val))
    }
    // if (this.toRecord) {
    //   this.history.record(JSON.parse(JSON.stringify(mmdata.data)))
    // }
    if (mmdata.data.title) {
      this.toUpdate = false
      this.$emit('change', [mmdata.getSource()])
      this.getListeAllNodes() // construction de la liste de tous les nodes
      this.updateMindmap()
    } else {
      // console.log('--> problemes de données dan le JSON : ', mmdata)
    }
  }

  init() {
    this.mindmapSvg = d3.select(this.$refs.svg)
    this.mindmapG = d3.select(this.$refs.content)
    this.mindmapG.style('opacity', 0)
    this.dummy = d3.select(this.$refs.dummy)
    // console.log('dummy', this.dummy)
    // svg
    this.mindmapSvg.on('contextmenu', () => { d3.event.preventDefault() })
    this.mindmapSvgZoom = this.zoom.on('zoom', () => { this.mindmapG.attr('transform', d3.event.transform) })
      .filter(() => (
        (d3.event.ctrlKey && d3.event.type !== 'mousedown')
        || (this.spaceKey && d3.event.type !== 'wheel')
      ) && !d3.event.button)
      .scaleExtent([0.1, 8])
      console.log('zoomable', this.zoomable)
  }

  initNodeEvent() {
    this.makeDrag(this.draggable)
    this.makeNodeAdd(this.showNodeAdd)
    this.makeContextMenu(this.contextMenu)
  }

  async makeKeyboard(val: boolean) {
    val ? this.mindmapSvg.on('keydown', this.svgKeyDown).on('keyup', this.svgKeyUp)
      : this.mindmapSvg.on('keydown', null).on('keyup', null)
  }

  // ajoute les events sur les nodes
  makeNodeAdd(val: boolean) {
    // const fObject = this.mindmapG.selectAll('foreignObject.objectTextNode') as d3.Selection<Element, FlexNode, Element, FlexNode>
    const boxNode = this.mindmapG.selectAll('.boxNode') as d3.Selection<Element, FlexNode, Element, FlexNode>
    const gEscalade = this.mindmapG.selectAll('.gEscalade') as d3.Selection<Element, FlexNode, Element, FlexNode>
    const gJT = this.mindmapG.selectAll('.gJumpTo') as d3.Selection<Element, FlexNode, Element, FlexNode>
    const infosNode = this.mindmapG.selectAll('.gInfos') as d3.Selection<Element, FlexNode, Element, FlexNode>
    const editionNode = this.mindmapG.selectAll('.gEdition') as d3.Selection<Element, FlexNode, Element, FlexNode>
    const expandNode = this.mindmapG.selectAll('.gBtnExpand') as d3.Selection<Element, FlexNode, Element, FlexNode>
    const collapseNode = this.mindmapG.selectAll('.gBtnCollapse') as d3.Selection<Element, FlexNode, Element, FlexNode>
    if (val) {
      const {
        mouseLeave,
        mouseEnter,
        mouseEnterJumpTo,
        mouseLeaveJumpTo,
        // gBtnClick,
        infosClick
      } = this
      // fObject.on('mouseenter', mouseEnter).on('mouseleave', mouseLeave)
      boxNode.on('mouseenter', mouseEnter).on('mouseleave', mouseLeave)
      gEscalade.on('mouseenter', mouseEnterJumpTo).on('mouseleave', mouseLeaveJumpTo)
      gJT.on('mouseenter', mouseEnterJumpTo).on('mouseleave', mouseLeaveJumpTo)
      // gBtn.on('mouseenter', mouseEnter).on('mouseleave', mouseLeave).on('mousedown', gBtnClick)
      infosNode.on('mouseenter', mouseEnter).on('mouseleave', mouseLeave).on('mousedown', infosClick)
      editionNode.on('mouseenter', mouseEnter).on('mouseleave', mouseLeave).on('mousedown', infosClick)
      expandNode.on('mouseenter', mouseEnter).on('mouseleave', mouseLeave)
      collapseNode.on('mouseenter', mouseEnter).on('mouseleave', mouseLeave)
    } else {
      // fObject.on('mouseenter', null).on('mouseleave', null)
      boxNode.on('mouseenter', null).on('mouseleave', null)
      gEscalade.on('mouseenter', null).on('mouseleave', null)
      gJT.on('mouseenter', null).on('mouseleave', null)
      // gBtn.on('mouseenter', null).on('mouseleave', null).on('mousedown', null)
      infosNode.on('mouseenter', null).on('mouseleave', null).on('mousedown', null)
      editionNode.on('mouseenter', null).on('mouseleave', null).on('mousedown', null)
      expandNode.on('mouseenter', null).on('mouseleave', null)
      collapseNode.on('mouseenter', null).on('mouseleave', null)
    }
  }

  makeContextMenu(val: boolean) {
    const selection = this.mindmapG.selectAll('.boxNode') as d3.Selection<Element, FlexNode, Element, FlexNode>
    if (val) {
      selection.on('contextmenu', this.fObjectRightClick)
    } else {
      selection.on('contextmenu', null)
    }
  }

  makeDrag(val: boolean) {
    // console.log('makeDrag', val)
    const { mindmapG, dragged, fObjMousedown, dragended } = this
    // const selection = mindmapG.selectAll('foreignObject.objectTextNode') as d3.Selection<Element, FlexNode, Element, FlexNode>
    const selection = mindmapG.selectAll('.boxNode') as d3.Selection<Element, FlexNode, Element, FlexNode>
    const drag = d3.drag().container((d, i, n) => n[i].parentNode?.parentNode as d3.DragContainerElement) as d3.DragBehavior<Element, FlexNode, FlexNode>
    if (val) {
      selection.call(drag.on('start', fObjMousedown).on('drag', dragged).on('end', dragended))
    } else {
      selection.call(drag.on('start', null).on('drag', null).on('end', null))
    }
  }

  async makeZoom(val: boolean) {
    // consol e.log('makeZoom')
    const { mindmapSvg, mindmapSvgZoom, zoom } = this
    if (val) {
      // console.log('d3.event', d3.event)
      mindmapSvg.call(mindmapSvgZoom).on('dblclick.zoom', null)
        .on('wheel.zoom', () => {
          const { ctrlKey, deltaY, deltaX, x, y } = d3.event
          // console.log('x', x)
          // console.log('y', y)
          // console.log('deltaY', deltaY)
          d3.event.preventDefault()
          const current = d3.zoomTransform(this.$refs.svg)
          if (ctrlKey) {
            const svgPos = this.$refs.svg.getBoundingClientRect()
            const px = svgPos.left + window.pageXOffset
            const py = svgPos.top + window.pageYOffset
            const k = current.k - (deltaY / 200)
            // console.log('px', px)
            // console.log('k', k)
            this.zoomNum = k // enregistre le niveau du zoom
            zoom.scaleTo(mindmapSvg, k, [x - px, y - py])
          } else {
            // console.log('Zoom', val)
            zoom.translateBy(mindmapSvg, -deltaX, -deltaY)
          }
        })
    } else {
      mindmapSvg.on('.zoom', null)
    }
  }

  // click sur zoom plus
  async makeZoomPlus(val: boolean) {
    // console.log('zoomPlus', val)
    if (val) {
      await d3.transition().end().then(() => {
        // console.log('this.zoomNum', this.zoomNum)
        let multiple = this.zoomNum + 0.2
        this.zoomNum = multiple  // enregistre le niveau du zoom
        // console.log('multiple', multiple)
        this.mindmapSvg.transition(this.easePolyInOut as any).call(this.zoom.scaleTo, multiple)
      })
    }
  }

  // click sur zoom moins
  async makeZoomMoins(val: boolean) {
    // console.log('zoomPlus', val)
    if (val) {
      await d3.transition().end().then(() => {
        // console.log('this.zoomNum', this.zoomNum)
        let multiple = this.zoomNum - 0.2
        this.zoomNum = multiple  // enregistre le niveau du zoom
        // console.log('multiple', multiple)
        this.mindmapSvg.transition(this.easePolyInOut as any).call(this.zoom.scaleTo, multiple)
      })
    }
  }

  // édite la mindmap
  editMap () {
    // const mindmap = this.mindmapG.selectAll('#mindmap') as d3.Selection<Element, FlexNode, Element, FlexNode>
    // console.log('mindmap', this.mindmapSvg)
    if(this.editeMap) {
      // mindmap.attr('class', '')
      this.mindmapSvg.classed('tf_grid', false)
      // document.getElementById('mindmap')?.classList.remove('tf_grid')
      this.editeMap = false
    } else {
      this.mindmapSvg.classed('tf_grid', true)
      // document.getElementById('mindmap')?.classList.add('tf_grid')
      this.editeMap = true
    }
    // console.log('editMap', this.editeMap)
    this.updateMindmap()
  }

  // ouvre la liste des chatbot dispo
  openMindmapListeChatbot () {
    this.$emit('openMindmapListeChatbot')
  }
  // ouvre le test du chatbot
  openFront () {
    this.$emit('openFront')
  }

  // button undo/redo
  undo() {
    if (this.canUndo) {
      this.toRecord = false
      this.updateMmdata(this.history.undo())
      this.drawPathJump()
    }
  }
  redo() {
    if (this.canRedo) {
      this.toRecord = false
      this.updateMmdata(this.history.redo())
      this.drawPathJump()
    }
  }

  afficheDossier () {
    // console.log('this.switchDossier', this.switchDossier)
    this.updateMmdata()
    this.drawPathJump() // redessine les path jumpTo
  }

  afficheTechnique () {
    // this.switchTechnique ? this.switchTechnique = false : this.switchTechnique = true
    // console.log('this.switchTechnique', this.switchTechnique)
    this.updateMmdata()
    this.drawPathJump() // redessine les path jumpTo
    // si l'autoscale est activé
    if (this.autoScale) {
      this.fitContent()
    }
  }

  // faire la difference entre un jumpto dans l'arbo ou vers une escalade
  jumpToData(dialog_node:string) {
    let data = {icone: 'location_on'}
    this.arrayAllNodes.forEach((n:any) => {
      if (n.value === dialog_node) {
        // retourne le nom de l'incone
        data = n
      }
    })
    return data
  }

  afficheJumpTo () {
    // this.switchTechnique ? this.switchTechnique = false : this.switchTechnique = true
    // console.log('this.switchJumpTo', this.switchJumpTo)
    this.updateMmdata()
    this.drawPathJump() // redessine les path jumpTo
    // si l'autoscale est activé
    if (this.autoScale) {
      this.fitContent()
    }
  }
  downloadFile(content: string, filename: string) {
    const eleLink = document.createElement('a')
    eleLink.download = filename
    eleLink.style.display = 'none'
    // blob
    const blob = new Blob([content])
    eleLink.href = URL.createObjectURL(blob)

    document.body.appendChild(eleLink)
    eleLink.click()

    document.body.removeChild(eleLink)
  }
  exportTo() {
    const data = mmdata.getSource()
    let content = ''
    let filename = data.name
    switch (this.selectedOption) {
      case 0: // JSON
        content = JSON.stringify(data, null, 2)
        filename += '.json'
        break
      case 2: // Markdown
        content = toMarkdown(data)
        filename += '.md'
        break
      default:
        break
    }
    this.downloadFile(content, filename)
  }

  //centre le contenu de la mindMap
  async makeCenter() {
    const coef = 1.6
    //console.log('makeCenter mmdata', mmdata)
    let decaleEditCascade = 0
    // si c'est uniquement un node cascade en edition
    if (typeof mmdata !== 'undefined' && !mmdata.data.generation && mmdata.data.cascade){
      decaleEditCascade = 0
    }
    await d3.transition().end().then(() => {
      let rect = (this.$refs.content as SVGGElement).getBBox()
      // let rect2 = (this.$refs.dummy as HTMLDivElement).getBBox()
      // console.log(' content rect',  rect)
      // console.log(' selectedBox rect2',  rect2)
      const div = this.$refs.mindmap
      // // console.log(' div',  div)
      // console.log('div.offsetWidth', div.offsetWidth)
      // console.log('div.offsetHeight', div.offsetHeight)
      // // console.log('taille et position du contenu mindmap',  rect)
      // console.log(' mindmap width',  (rect.width * this.zoomNum))
      // console.log(' mindmap height',  rect.height)
      // console.log('this.mindmapSvg', this.mindmapSvg)
      // console.log(' mindmap  x',  rect.x)
      // console.log(' mindmap  y',  rect.y)
      let difHeight = div.offsetHeight-rect.height
      let posX = (div.offsetWidth - (rect.width * this.zoomNum))
      // let posX = (rect.width) - (div.offsetWidth/2) + decaleEditCascade
      // let posX = ((rect.width) / 1.3) + (rect.x) + decaleEditCascade
      let posY = ((rect.height) / 1.2) + (rect.y) 
      // console.log('posX', posX)
      // pour la hauteur
      if ((div.offsetHeight-(rect.height) < (div.offsetHeight / 2))) {
        // console.log('ca rentre plus en hauteur', div.offsetHeight-(rect.height))
        // posY = 0
        posY = posY + (rect.y / coef)
      } else {
        // console.log('ca rentre en hauteur')
        posY = posY + (rect.y / coef)
      }
      // pour la largeur
      if ((div.offsetWidth-(rect.width) < (div.offsetWidth / 2))) {
        // console.log('ca rentre plus en largeur')
        // posX = posX - Math.abs(rect.x)
        // posX = posX + (rect.width / 2)
        // console.log('calc width', (div.offsetWidth / this.zoomNum) - (rect.width/2 ))
        // ca semble ok cette formule !!!
        posX =  (((((div.offsetWidth / this.zoomNum) - (rect.width / 2))) - posX) + rect.x)  + decaleEditCascade + ((difHeight/2) / this.zoomNum)
      } else {
        // console.log('ca rentre en largeur')
        // posX =( posX + 50)  + decaleEditCascade
        posX =  (((((div.offsetWidth / this.zoomNum) - (rect.width / 2))) - posX) + rect.x)  + decaleEditCascade + ((difHeight/2) / this.zoomNum)
      }
      
      // console.log('node 0 : posX', posX)
      // console.log('node 0 : posY', posY)
      // console.log('this.zoomnum', this.zoomNum)
      // this.mindmapSvg.select('g_0').transition(this.easePolyInOut as any).call(this.zoom.translateTo, posX, posY)
      this.mindmapSvg.transition(this.easePolyInOut as any).call(this.zoom.translateTo, posX, posY)
    })
  }

  //ajuste le contenu de la mindMap
  async fitContent() {
    await d3.transition().end().then(() => {
      const rect = (this.$refs.content as SVGGElement).getBBox()
      // console.log('rect', rect)
      const div = this.$refs.mindmap
      const multipleX = (div.offsetWidth / rect.width)/1.1
      // console.log('multipleX', multipleX)
      const multipleY = (div.offsetHeight / rect.height)/1.1
      // console.log('multipleY', multipleY)
      const multiple = Math.min(multipleX, multipleY)
      // console.log('multiple', multiple)
      this.zoomNum = multiple  // enregistre le niveau du zoom
      this.mindmapSvg.transition(this.easePolyInOut as any).call(this.zoom.scaleTo, multiple)
      // console.log('mindmapSvg', this.mindmapSvg)
    })
    await this.makeCenter()
  }

  add(dParent: Mdata, d: Data) {
    // console.log('add node dParent', dParent)
    // console.log('add node d', d)
    this.toRecord = true
    const nd = mmdata.add(dParent.id, d)
    // this.updateMmdata()
    return nd
  }
  modifJumpTo(dParent: Mdata, nextStep: string) {
    let nextStepData = ''
    if (nextStep) {
      nextStepData = nextStep
    }
    // console.log('modifJumpTo')
    // console.log('add node dParent', dParent)
    // console.log('add node nextStepData', nextStepData)
    this.toRecord = true
    const nd = mmdata.changeNextStepNode(dParent.id, nextStepData)
    // this.updateMmdata()
    return nd
  }
  insert(dPosition: Mdata, d: Data, i = 0) {
    this.toRecord = true
    const nd = mmdata.insert(dPosition.id, d, i)
    this.updateMmdata()
    return nd
  }
  move(del: Mdata, insert?: Mdata, i = 0) {
    console.log('move')
    this.toRecord = true
    mmdata.move(del.id, insert?.id, i)
    this.updateMmdata()
    this.drawPathJump() // redessine les path jumpto
  }
  reparent(parentNode: Mdata, node: Mdata) {
    // console.log('reparent', node)
    this.toRecord = true
    mmdata.reparent(parentNode, node)
    this.updateMmdata()
    this.drawPathJump() // redessine les path jumpto
  }

  //--- voir les infos du node ---//
  nodeViewInfos(selectNode: FlexNode) {
    // console.log('nodeViewInfos :', selectNode.data)
    // console.log('this.cloneFlexNode', this.cloneFlexNode)
    // clone le node selectionné (flexNode)
    // this.cloneFlexNode = Object.assign({}, selectNode)
    // this.cloneFlexNode = JSON.parse(JSON.stringify(selectNode.data))
    // les data à passer à la vue
    // let dataInfos = {
    //   'title': selectNode.data.title,
    //   'label': selectNode.data.label,
    //   'link': String(selectNode.data.link),
    //   'id': selectNode.data.id,
    //   'type': selectNode.data.type,
    //   'response_type': selectNode.data.response_type,
    //   'selection_policy': selectNode.data.selection_policy,
    //   'conditions': selectNode.data.conditions,
    //   'options': selectNode.data.options,
    //   'next_step': selectNode.data.next_step,
    //   'dialog_node': selectNode.data.dialog_node
    // }

    let dataInfos = Object.assign(selectNode.data)
    // let dataInfos:any = _.cloneDeep(selectNode.data) // ca marche pas bien
    // retire les pauses dans le "output
    dataInfos = this.removeNodeDelay(dataInfos)
    // console.log('dataInfos', dataInfos)
    // si il y a un jumpTo deja selectionné
    if (dataInfos.next_step && dataInfos.next_step.dialog_node) {
      this.newJumpTo.push(dataInfos.next_step.dialog_node)
      this.getInfosJumpTo(dataInfos.next_step.dialog_node) // recupere les infos du jumpTo
    }

    // si il y a un transfert deja selectionné
    if (dataInfos.output.targetfirst) {
      if (dataInfos.output.targetfirst.meeting) {
        this.newTransfert = 'meeting'
      } else if (dataInfos.output.targetfirst.transfert) {
        this.newTransfert = 'chat'
      } else if (dataInfos.output.targetfirst.c2c) {
        this.newTransfert = 'c2c'
      } else if (dataInfos.output.targetfirst.form) {
        this.newTransfert = 'form'
      }
    }
    
    // si il y a une liste d'options
    let options:any[] = []
    let optionsLabel:any[] = []
    if (selectNode.data.options) {
      selectNode.data.options.forEach(function(item){
        options.push(item)
      })
    }
    options.forEach(function(item){
      optionsLabel.push(item.label)
    })
    this.selectNodeInfosOptions = optionsLabel
    this.nodeInfosOptions = optionsLabel
    this.selectNodeInfos = dataInfos
    // console.log('selectNodeInfosOptions', this.selectNodeInfosOptions)
    // console.log('nodeInfosOptions', this.nodeInfosOptions)
    // console.log('selectNodeInfos', this.selectNodeInfos)
    // this.$emit('updateNodeOptions', s)
    // verification du contenu du node (il faut un output.generic minimum)
    this.showPopUpOption = true
    // ferme l'editeur de text
    this.editTxtNum = -1
    this.editOptionNum = -1
    this.editTitleNum = -1
    this.editJumpNum = -1
  }

//--- efface le node ---//
  del(s: Mdata | Mdata[]) {
    // console.log('del', s)
    this.toRecord = true
    if (Array.isArray(s)) {
      const idArr = []
      for (let i = 0; i < s.length; i++) {
        idArr.push(s[i].id)
      }
      mmdata.del(idArr)
    } else {
      mmdata.del(s.id)
    }
    this.updateMmdata()
  }

  updateName(d: Mdata, name: string) {
    // console.log('--> updateName')
    if (d.title !== name) {
      // console.log('updateName', d)
      this.toRecord = true
      const nd = mmdata.rename(d.id, name)
      this.updateMmdata()
      this.$emit('updateBddAndWatson', d.dialog_node, name)
      return nd
    }
  }

  //--- retract la branche ---//
  collapse(data: Mdata | Mdata[]) {
    // console.log('--- collapse ----------')
    this.toRecord = true
    if (Array.isArray(data)) {
      const idArr = []
      for (let i = 0; i < data.length; i++) {
        idArr.push(data[i].id)
      }
      mmdata.collapse(idArr)
    } else {
      mmdata.collapse(data.id)
    }
    this.updateMmdata()
    this.drawPathJump()
    // si l'autoscale est activé
    if (this.autoScale) {
      this.fitContent()
    }
  }

  //--- deploie la branche ---//
  expand(data: Mdata | Mdata[]) {
    this.toRecord = true
    if (Array.isArray(data)) {
      const idArr = []
      for (let i = 0; i < data.length; i++) {
        idArr.push(data[i].id)
      }
      mmdata.expand(idArr)
    } else {
      mmdata.expand(data.id)
    }
    this.updateMmdata()
    this.drawPathJump()
    // si l'autoscale est activé
    if (this.autoScale) {
      this.fitContent()
    }
  }

  //etandre toutes les branches
  async allExpande() {
    await d3.transition().end().then(() => {
      mmdata.allExpande()
    })
    this.updateMmdata()
    this.drawPathJump()
    // si l'autoscale est activé
    if (this.autoScale) {
      this.fitContent()
    }
  }

  // svg keyDown
  svgKeyDown() {
    const event = d3.event
    const keyName = event.key as string
    // console.log('keyName', keyName)
    if (keyName === ' ' && !this.spaceKey) {
      console.log('space')
      this.spaceKey = true
    }
    // console.log('event.metaKey', event.metaKey)
    if (event.metaKey) {
      if (keyName === 'z') {
        // console.log('keyName z')
        // d3.event.preventDefault()
        // this.undo()
      } else if (keyName === 'y') {
        // console.log('keyName z')
        // d3.event.preventDefault()
        // this.redo()
      }
    }
  }
  svgKeyUp() {
    if (d3.event.key === ' ') { this.spaceKey = false }
  }
  divKeyDown() {
    if (d3.event.key === 'Enter') {
      // d3.event.preventDefault()
      // document.execCommand('insertHTML', false, '<br>')
    }
  }

  // efface un transfert du node
  delTransfert () {
    // console.log('delTransfert')
    this.editorToggleHTML = false
    this.newTransfert = ''
    this.editNewTransfert = false
    this.selectNodeInfos.output.targetfirst = ''
  }

  // efface un jumpto du node
  delJumpTo () {
    // console.log('delJumpTo')
    this.editorToggleHTML = false
    this.editNewJumpTo = false
    this.newJumpTo = []
    this.selectNodeInfos.next_step = ''
  }

  // plus utilisé, à verifier
  // update node name
  updateNodeName() {
    // console.log('updateNodeName')
    const editP = document.querySelector('#editing > foreignObject.objectTextNode > div') as HTMLDivElement
    window.getSelection()?.removeAllRanges()
    const editText = editP.innerText || ''
    this.mindmapG.select('g#editing').each((d, i, n) => {
      (n[i] as Element).removeAttribute('id')
      const nd = this.updateName(d.data, editText)
      // console.log('updateNodeName nd', nd)
      if (nd) {
        this.$emit('updateNodeName', mmdata.getSource(nd.id), nd.id)
      }
    })
    editP.setAttribute('contenteditable', 'false')
  }
  
  removeSelectedId() {
    const editP = document.querySelector('#editing > foreignObject.objectTextNode') as HTMLDivElement
    const sele = document.getElementById('selectedNode')
    // console.log('removeSelectedId', editP)
    if (sele) {
      // console.log('remove node selected')
      sele.setAttribute('__click__', '0')
      sele.removeAttribute('id')
      // d3.select(sele).selectAll('foreignObject').attr('width', '100%')
    }
    if (editP) {
      // console.log('remove node editing text')
      let widthText = editP.clientWidth + (this.foreignBorderWidth * 2)
      // const b1 = getComputedStyle(editP).borderTopWidth
      // const b2 = getComputedStyle(editP.parentNode as Element).borderTopWidth
      // const spacing = (parseInt(b1, 10) + parseInt(b2, 10)) || 0
      // let calcWidth = widthText + spacing * 2
      let newWidthTxt = widthText >= this.textWidth ? this.textWidth : widthText
      // console.log('newWidthTxt', newWidthTxt)
      d3.select(editP).attr('width', newWidthTxt)

    }
  }

  selectNode(n: Element, node: FlexNode) {
    // console.log('selectNode : node', node)
    this.selectNodeCoords = [] // vide le tableau a chaque fois
    let objectDataNode:any
    objectDataNode = node.data
    if(objectDataNode.next_step && objectDataNode.next_step.behavior == 'jump_to') {
      // let nodeName = d.data.next_step
      // console.log('select node next_step',objectDataNode.next_step.dialog_node)
      let FindSource:any = document.getElementById(node.data.dialog_node)
      let jumpToX = Math.round(FindSource.getBoundingClientRect().x)
      let jumpToY = Math.round(FindSource.getBoundingClientRect().y)
      this.selectNodeCoords.push(jumpToX)
      this.selectNodeCoords.push(jumpToY)
    }

    // this.removeMultiSelected()
    // const fObj = d3.select(n).selectAll('foreignObject.objectTextNode').filter((a, b, c) => (c[b] as Element).parentNode === n) as d3.Selection<Element, FlexNode, Element, FlexNode>
    // console.log('fObj', fObj)
    if (n.getAttribute('id') !== 'selectedNode') {
      this.removeSelectedId()
      n.setAttribute('id', 'selectedNode')

      // const b1 = getComputedStyle(n).borderTopWidth
      // const b2 = getComputedStyle(n.parentNode as Element).borderTopWidth
      // const spacing = (parseInt(b1, 10) + parseInt(b2, 10)) || 0
      let calcWidth = node.data.size[1] - this.xSpacing
      // uniquement pour le premier node
      if(node.data.id === '0') {
        calcWidth = (node.data.size[1] / 2) 
      }
      // console.log('selectNode calcWidth : ', calcWidth)
      let widthTxt = String(calcWidth >= this.textWidth ? this.textWidth : calcWidth)
      // console.log('selectNode widthTxt : ', widthTxt)
      const parentdiv = document.querySelector('#editing > foreignObject.objectTextNode')
      if (parentdiv) {
        parentdiv.setAttribute('width', widthTxt)
      }
    }
  }

  editNode(n: Element) {
    // console.log('editNode : n', n)
    this.removeSelectedId()
    n.setAttribute('id', 'editing')
    const fObj = d3.select(n).selectAll('foreignObject.objectTextNode').filter((a, b, c) => (c[b] as Element).parentNode === n) as d3.Selection<Element, FlexNode, Element, FlexNode>
    this.focusNode(fObj)
    fObj.select('div').attr('contenteditable', true)
    const fdiv = document.querySelector('#editing > foreignObject.objectTextNode > div')
    const parentdiv = document.querySelector('#editing > foreignObject.objectTextNode')
    if (fdiv) {
      let widthText = String(fdiv.clientWidth + 6)
      // console.log('editNode : widthText', fdiv)
      window.getSelection()?.selectAllChildren(fdiv)
      if (parentdiv) {
        parentdiv.setAttribute('width', widthText)
      }
      // d3.select(n).selectAll('foreignObject').attr('width', widthText)
    }
  }

  focusNode(fObj: d3.Selection<Element, FlexNode, Element | null, FlexNode | undefined>) {
    // console.log('focusNode')
    const { k } = d3.zoomTransform(this.$refs.svg)
    const fObjPos = (fObj.node() as Element).getBoundingClientRect()
    if (fObjPos) {
      const svgPos = this.$refs.svg.getBoundingClientRect()
      // console.log('fObjPos', fObjPos)
      const r = fObjPos.right - svgPos.right
      const b = fObjPos.bottom - svgPos.bottom
      const l = fObjPos.left - svgPos.left
      const t = fObjPos.top - svgPos.top
      const x = (r > 0 && r) || (l < 0 && l)
      const y = (b > 0 && b) || (t < 0 && t)

      if (x) { this.mindmapSvg.call(this.zoom.translateBy, -x / k, 0) }
      if (y) { this.mindmapSvg.call(this.zoom.translateBy, 0, -y / k) }
    }
  }
  
  editNew(newD: Mdata, depth: number, pNode: Element) {
    // console.log('editNew')
    d3.transition().end().then(() => {
      const node = d3.select(pNode).selectAll(`g.node.depth_${depth}`)
        .filter((b) => (b as FlexNode).data.id === newD.id)
        .node()

      this.editNode(node as Element)
    }, (err) => {
      console.log(err)
    })
  }
  fdivMouseDown() {
    // console.log('fdivMouseDown')
    const flag = d3.event.target.getAttribute('contenteditable')
    if (flag === 'true') {
      d3.event.stopPropagation() // drag、click
    }
  }
  fObjMousedown(d: FlexNode, i: number, n: ArrayLike<Element>) {
    // uniquement si editeMap activé

      // console.log('fObjMousedown d', d)
      // console.log('fObjMousedown i', i)
      // console.log('fObjMousedown n', n)
      // let flag = 0
      const clickedNode = n[i].parentNode as Element
      // console.log('clickedNode', clickedNode)
      // const edit = clickedNode.id
      // console.log('editeur de text', edit)
      // if (edit) {
      //   // const f = (
      //   //   d3.selectAll('foreignObject').filter((d, i, n) => (n[i] as Element).parentNode.id === edit).node() as Element
      //   // ).firstElementChild as HTMLElement
      //   // f.blur()
      //   // flag = 1
      //   this.selectNode(clickedNode, d)
      // }
      // if (!edit || flag) {
        
        this.selectNode(clickedNode, d)
      // }

  }

 
  fObjectClick(d: FlexNode, i: number, n: ArrayLike<Element>) {
    const sele = document.getElementById('selectedNode')
    // console.log('sele', sele)
    const { dragFlag } = this
    if (sele) {
      if (sele.getAttribute('__click__') === '1'
      && n[i].parentNode === sele
      && document.activeElement !== n[i].firstElementChild
      && !dragFlag) {
        //console.log('sele', sele)
        // this.editNode(sele)
        // le node selectionné
        this.selectMenuNode = d
        // le clone les data du node selectionné
        this.cloneFlexNode = _.cloneDeep(d)
        // this.cloneFlexNode = JSON.parse(JSON.stringify(d))
        this.nodeViewInfos(d)
        sele.setAttribute('__click__', '0')
      } else {
        // console.log('sele id', sele.getAttribute('id'))
        sele.setAttribute('__click__', '1')
        if (!dragFlag) {
          this.$emit('click', mmdata.getSource(d.data.id), d.data.id)
        }
      }
    }
  }

  //--- clique sur le bouton add node ---//
  // gBtnClick(a: FlexNode, i: number, n: ArrayLike<Element>) {
  //   if ((n[i] as SVGElement).style.opacity === '1') {
  //     d3.event.stopPropagation()
  //     const d: FlexNode = d3.select(n[i].parentNode as Element).data()[0] as FlexNode
  //     const newD = this.add(d.data, { name: '' })
  //     this.mouseLeave(d, i, n)
  //     if (newD) {
  //       this.editNew(newD, d.depth + 1, n[i].parentNode as Element)
  //     }
  //   }
  // }


  //--- clique sur le bouton infos node ---//
  infosClick(selectNode: FlexNode, i: number, n: ArrayLike<Element>) {
    if ((n[i] as SVGElement).style.opacity === '1') {
      d3.event.stopPropagation()
      // const d: FlexNode = d3.select(n[i].parentNode as Element).data()[0] as FlexNode
      // this.mouseLeave(d, i, n)
      // console.log('infos node mmdata', mmdata)
      // console.log('infos node', selectNode)
      // le node selectionné
      this.selectMenuNode = selectNode
      // le clone les data du node selectionné
      this.cloneFlexNode = _.cloneDeep(selectNode)
      // console.log('infosClick', selectNode)
      this.nodeViewInfos(selectNode)
    }
  }

  nodeClick(selectNode: FlexNode, i: number, n: ArrayLike<Element>) {
    if ((n[i] as SVGElement).style.opacity === '1') {
      d3.event.stopPropagation()
      // const d: FlexNode = d3.select(n[i].parentNode as Element).data()[0] as FlexNode
      // this.mouseLeave(d, i, n)
      // console.log('click node', selectNode)
      // le node selectionné
      this.selectMenuNode = selectNode
      // le clone les data du node selectionné
      this.cloneFlexNode = _.cloneDeep(selectNode)
      // console.log('nodeClick', selectNode)
      this.nodeViewInfos(selectNode)
    }
  }

  //--- Menu clique droit ---//
  fObjectRightClick(node: FlexNode, i: number, n: ArrayLike<Element>) {
      const sele = document.getElementById('selectedNode')
      const edit = document.getElementById('editing')
      const clickedNode = n[i].parentNode as Element
      // console.log('fObjectRightClick', clickedNode)
      const show = () => {
        const pos = this.getViewPos()
        this.contextMenuX = pos.left
        this.contextMenuY = pos.top
        this.showContextMenu = true
        this.selectMenuNode = node
        this.clearSelection()
        setTimeout(() => { this.$refs.menu.focus() }, 300)
      }
      if (clickedNode.classList.contains('multiSelectedNode')) {
        const t: Mdata[] = []
        ;(this.mindmapG.selectAll('g.multiSelectedNode') as d3.Selection<Element, FlexNode, Element, FlexNode>)
          .each((node) => { t.push(node.data) })
        const collapseFlag = t.filter((node) => node.children && node.children.length > 0).length > 0
        const expandFlag = t.filter((node) => node._children && node._children.length > 0).length > 0
        this.contextMenuItems[1].disabled = !collapseFlag
        this.contextMenuItems[2].disabled = !expandFlag
        this.contextMenuTarget = t
        show()
      } else if (clickedNode !== edit) {
        if (clickedNode !== sele) {
          this.selectNode(clickedNode, node)
        }
        const { data } = node
        this.contextMenuItems[1].disabled = !(data.children && data.children.length > 0)
        this.contextMenuItems[2].disabled = !(data._children && data._children.length > 0)
        this.contextMenuTarget = data
        show()
      }
  }

  clickMenu(key: string) {
    this.showContextMenu = false
    const { contextMenuTarget } = this
    // console.log('clickMenu', this.selectMenuNode)
    switch (key) {
      case 'Delete':
        // console.log('delete item')
        this.del(contextMenuTarget)
        break
      case 'Collapse':
        this.collapse(contextMenuTarget)
        // console.log(contextMenuTarget)
        break
      case 'Expand':
        this.expand(contextMenuTarget)
        // console.log(contextMenuTarget)
        break
      case 'Infos':
        // le clone les data du node selectionné
        this.cloneFlexNode = _.cloneDeep(this.selectMenuNode)
        this.nodeViewInfos(this.selectMenuNode)
        break
      default:
        break
    }
    (this.$refs.svg as HTMLElement).focus()
    this.removeSelectedId()
  }

  //--- quitte le survol du node ---//
  mouseLeave(d: FlexNode, i: number, n: ArrayLike<Element>) {
    // console.log('mouseLeave')
    // uniquement en mode editable
/*
    if(this.editeMap){
      // bouton ajouter node
      if ((n[i] as SVGElement).className.baseVal.includes('gButton')) {
        d3.select(n[i]).style('opacity', 0)
      } else {
        d3.selectAll('g.gButton').filter((a, b, c) => (c[b] as Element).parentNode === n[i].parentNode).style('opacity', 0)
      }
    }
*/
    // bouton expand node
    if ((n[i] as SVGElement).className.baseVal.includes('gBtnExpand')) {
      d3.select(n[i]).style('opacity', 0)
    }

    // bouton collapse node
    // if ((n[i] as SVGElement).className.baseVal.includes('gBtnCollapse')) {
    //   d3.select(n[i]).style('opacity', 0)
    // } else {
      d3.selectAll('g.gBtnCollapse').filter((a, b, c) => (c[b] as Element).parentNode === n[i].parentNode).style('opacity', 0)
    // }

    // bouton infos nod
    if ((n[i] as SVGElement).className.baseVal.includes('gInfos')) {
      d3.select(n[i]).style('opacity', 0)
    } else {
      d3.selectAll('g.gInfos').filter((a, b, c) => (c[b] as Element).parentNode === n[i].parentNode).style('opacity', 0)
    }
    // bouton edition nod
    if ((n[i] as SVGElement).className.baseVal.includes('gEdition')) {
      d3.select(n[i]).style('opacity', 0)
    } else {
      d3.selectAll('g.gEdition').filter((a, b, c) => (c[b] as Element).parentNode === n[i].parentNode).style('opacity', 0)
    }

    // le path jumpTo si il y a et si les jumpto sont affiché
    if(this.switchJumpTo) {
      d3.select('path#jumpTo_'+d.data.id).filter((a, b, c) => (c[b] as Element).parentNode === n[i].parentNode).style('visibility', 'hidden')
    }
  }

  //--- au survol du node ---//
  mouseEnter(d: FlexNode, i: number, n: ArrayLike<Element>) {
    // console.log('mouseEnter')
    // ne pas affiche si la branche est rétractée
    const flag = (d.data._children?.length || 0) > 0
    // uniquement en mode editable
/*
    if(this.editeMap){
      if (!flag) {
        // bouton ajouter node
        if ((n[i] as SVGElement).className.baseVal.includes('gButton')) {
          d3.select(n[i]).style('opacity', 1)
        } else {
          d3.selectAll('g.gButton').filter((a, b, c) => (c[b] as Element).parentNode === n[i].parentNode).style('opacity', 0.8)
        }
      // afficher si la branche est rétractée
      }
    }
*/
    if (flag) {
      // uniquement survole du bouton expand node
      if ((n[i] as SVGElement).className.baseVal.includes('gBtnExpand')) {
        d3.select(n[i]).style('opacity', 1)
      }
    } else {
      // uniquement survole du bouton collapse node
      if ((n[i] as SVGElement).className.baseVal.includes('gBtnCollapse')) {
         d3.select(n[i]).style('opacity', 1)
      }
    }

    if(!this.editeMap) {
      // bouton infos node uniquement si mode edition desactivé
      if ((n[i] as SVGElement).className.baseVal.includes('gInfos')) {
        d3.select(n[i]).style('opacity', 1)
      } else {
        d3.selectAll('g.gInfos').filter((a, b, c) => (c[b] as Element).parentNode === n[i].parentNode).style('opacity', 1)
      }
    } else {
      // bouton edition node uniquement en mode edition
      if ((n[i] as SVGElement).className.baseVal.includes('gEdition')) {
        d3.select(n[i]).style('opacity', 1)
      } else {
        d3.selectAll('g.gEdition').filter((a, b, c) => (c[b] as Element).parentNode === n[i].parentNode).style('opacity', 1)
      }
    }

    // le path jumpTo si il y a et si les jumpto sont affiché
    if(this.switchJumpTo) {
      d3.select('path#jumpTo_'+d.data.id).filter((a, b, c) => (c[b] as Element).parentNode === n[i].parentNode).style('visibility', 'visible')
    }
  }


  //--- au survol du point jumpTo ---//
  mouseEnterJumpTo(d: FlexNode, i: number, n: ArrayLike<Element>) {
    // console.log('mouseEnterJumpTo', d.data)
    // permet de placer la branche racine du node survolé au premier plan
    d3.select('#g_' + d.data.id).raise()
    // et aussi passer au premier lan le text du node 0
    d3.select('#boxNode_0').raise()
    // d3.select('#Bienvenue').raise()
    d3.select('.gen0').raise()
    // recupere la largeur de la box pour lui attribuer dans le style
    const txtJumptoWidth =  d3.select('#g_' + d.data.id + ' .objectTextNodeJumpTo').attr('width')
    // console.log('txtJumptoWidth', txtJumptoWidth)

    // d3.selectAll('g.gInfos').filter((a, b, c) => (c[b] as Element).parentNode === n[i].parentNode).style('opacity', 1)
    d3.selectAll('foreignObject.objectTextNodeJumpTo').filter((a, b, c) => (c[b] as Element).parentNode === n[i].parentNode)
    // .style('box-shadow', '0px 1px 10px 1px rgba(0,0,0,0.15)')
    .style('opacity', 1)
    .style('width', txtJumptoWidth)

    // le path jumpTo si il y a et si les jumpto sont affiché
    if(this.switchJumpTo) {
      d3.select('path#jumpTo_'+d.data.id).filter((a, b, c) => (c[b] as Element).parentNode === n[i].parentNode).style('visibility', 'visible')
    }
  }
  
  //--- quand on quitte le survol du point jumpTo ---//
  mouseLeaveJumpTo(d: FlexNode, i: number, n: ArrayLike<Element>) {
    // console.log('mouseLeaveJumpTo')
    // d3.selectAll('g.gInfos').filter((a, b, c) => (c[b] as Element).parentNode === n[i].parentNode).style('opacity', 1)
    d3.selectAll('foreignObject.objectTextNodeJumpTo').filter((a, b, c) => (c[b] as Element).parentNode === n[i].parentNode)
    // .style('background-color', 'inherit')
    .style('box-shadow', 'none')
    .style('opacity', 0)
    .style('width', 10) // reduction de la largeur pour eviter les probleme de chevauchement

    // le path jumpTo si il y a et si les jumpto sont affiché
    if(this.switchJumpTo) {
      d3.select('path#jumpTo_'+d.data.id).filter((a, b, c) => (c[b] as Element).parentNode === n[i].parentNode).style('visibility', 'hidden')
    }
  }

  //--- drage and drop ---//
  draggedNodeRenew(draggedNode: Element, px: number, py: number, dura = 0, node: FlexNode) {
    // uniquement en mode editable
    if (node.depth && this.editeMap) {
      px = Math.round(px)
      py = Math.round(py)
      // console.log('draggedNodeRenew node:', node)
      // console.log('draggedNodeRenew draggedNode', draggedNode)
      const { pathJumpToMove, path, renewOffset, xSpacing } = this
      renewOffset(node, px, py)
      // console.log('draggedNodeRenew', py)
      let targetY = node.dy + py // y
      const targetX = node.dx + px // x
      const tran = d3.transition().duration(dura).ease(d3.easePoly)
      // console.log('-1 : targetY', targetY)
      // const textWidth = d3.select('foreignObject.objectTextNode').attr('width')
      // console.log('textWidth', textWidth)

      // 470 c'est la largeur max donc il ne faut pas applique le xspacing dessus
      if (node.data.left) {
        if (targetY < 470) {
          if (targetY > 410) {
            targetY = targetY - (470 - targetY) 
          } else {
            targetY = targetY - xSpacing 
          }
        }
      } else {
        if (targetY < 470) {
          if (targetY > 410) {
            targetY = targetY + (470 - targetY) 
          } else {
            targetY = targetY + xSpacing 
          }
        }
      }
      // console.log('+ xSpacing', xSpacing)
      // console.log('-2 : targetY', targetY)

      d3.select(draggedNode).transition(tran as any).attr('transform', `translate(${targetY},${targetX})`)
      // draggedNodepath
      d3.select('path#path_'+node.data.id)
      .transition(tran as any)
      .attr('d', path(node))

      // si il y a un path jumpTo
      d3.select(`path#jumpTo_${node.data.id}`)
      .transition(tran as any)
      .attr('d', pathJumpToMove(node))
    }
  }

  renewOffset(node: FlexNode, px: number, py: number) {
    // console.log('renewOffset', px + ' - ' +py)
    node.px = Math.round(px)
    node.py = Math.round(py)
    if (node.children) {
      for (let index = 0; index < node.children.length; index += 1) {
        const dChild = node.children[index]
        // console.log('dChild', dChild)
        this.renewOffset(dChild, px, py)
      }
    }
  }

  dragged(node: FlexNode, i: number, n: ArrayLike<Element>) {
    // console.log('dragged node', node)
    // console.log('dragged i', i)
    // console.log('dragged n', n)
    this.dragFlag = true
    // uniquement en mode editable
    if (node.depth && this.editeMap) {
      const { mindmapG, xSpacing, foreignX, foreignY } = this
      const draggedNode = n[i].parentNode as Element
      // console.log('draggedNode', draggedNode)
      draggedNode.setAttribute('style', 'opacity: 0.4')
      this.draggedNodeRenew(draggedNode, d3.event.y - node.y, d3.event.x - node.x, undefined, node)
      // this.$refs.content
      const t = d3.mouse(this.$refs.content as SVGGElement)
      let targetY = t[0] // x
      let targetX = t[1] // y

      // console.log('decalageNode0', this.decalageNode0)
      // others
      ;(mindmapG.selectAll('g.boxNode') as d3.Selection<Element, FlexNode, Element, FlexNode>)
      .filter((d, i, n) => draggedNode !== n[i] && draggedNode.parentNode !== n[i])
      .each((d, i, n) => {
        if (!d.data.next_step && !d.data.private) {
          const gNode = n[i]
          let forLeft

          if (d.data.left) {
            forLeft = d.y - (xSpacing*(d.depth))
          }else {
            forLeft = d.y + (xSpacing*(d.depth))
          }
          // const rect = {
          //   y: foreignX(d) + forLeft, // foreignObject x
          //   x: foreignY(d) + (d.x - 4), // foreignObject y
          //   width: d.size[1] - xSpacing,
          //   height: d.size[0] + 8,
          // }
          
          // ne pas activer les zones de tous ses enfants
          const nodeIdLength = node.data.id.length // id du node deplacé
          // si c'est un enfants du node deplacé compere les premiers chiffres de l'id
          const dId = d.data.id.slice(0, nodeIdLength)
          const rect = {
            y: foreignX(d) + (forLeft + (!d.data.generation ? (this.decalageNode0*2) : this.decalageNode0)), // foreignObject x
            x: foreignY(d) + (d.x - 22), // foreignObject y
            width: d.data.size[1] < d.data.optionSize[1] ? d.data.optionSize[1] : d.data.size[1] ,
            height: d.data.size[0] + 30,
          }
          // console.log('rect', rect)

          // on ne pas deplacer un node dans le meme node
          // ou dans un de ses enfants
          // ou dans un node avec un jumpto
          // ou dans un node avec une escalade
          if (node.data.dialog_node != d.data.dialog_node
            && node.data.id != dId
            && d.data.next_step == ''
            && !d.data.output.targetfirst
          ){
            // if (node.parent && node.parent.data.size[1] < node.parent.data.optionSize[1]) {
            //   targetX = targetX + (node.parent.data.optionSize[1] - node.parent.data.size[1])
            // }
            // console.log('targetX', targetX)
            
            if ((targetY > rect.y) && (targetY < rect.y + rect.width)
            && (targetX > rect.x) && (targetX < rect.x + rect.height)) {
              // console.log('targetY', targetY)
              // console.log('forLeft', forLeft)
              // console.log('dragged survol zone', d.data.title)
              // console.log('dragged survol zone y', d.y + ' - ' + foreignY(d))
              // console.log('rect', rect)
              gNode.setAttribute('id', 'newParentNode')
            } else if (gNode.getAttribute('id') === 'newParentNode') {
              // gNode.removeAttribute('id')
              // replace le bon id du node
              gNode.setAttribute('id', 'boxNode_' + d.data.id)
            }
          }
        }
      })
    }
  }
  
  dragback(node: FlexNode, draggedNode: Element) {
    // console.log('dragback', node)
    // uniquement en mode editable
    if (node.depth && this.editeMap) {
      const { pathJumpToBack} = this
      // console.log('dragback', draggedNode)
      // console.log('dragback', node)
      this.draggedNodeRenew(draggedNode, 0, 0, 1000, node)

      // console.log('retour à la case depart !', node.data.id)
      // console.log('selectNodeCoords', this.selectNodeCoords)

      if (d3.select(`path#jumpTo_${node.data.id}`)) {
        // console.log('path id :', node.data.id)
        let objectDataNode:any
        objectDataNode = node.data
        if(objectDataNode.next_step && objectDataNode.next_step.behavior == 'jump_to') {
          // console.log('ceci est un path jump', objectDataNode.next_step)
          // let nodeName = d.data.next_step
          // console.log('next_step',objectDataNode.next_step.dialog_node)
          let FindSource:any = document.getElementById(node.data.dialog_node)
          let FindJumpTo:any = document.getElementById('point_' + objectDataNode.next_step.dialog_node)
          // let textWidth = node.size[1] >= this.textWidth ? this.textWidth : (node.size[1] - xSpacing)

          // si il existe un node pour jump to
          if (FindJumpTo) {
            let jumpToX = (Math.round(FindJumpTo.getBoundingClientRect().x) + (this.gPointSize / 2))
            let jumpToY = (Math.round(FindJumpTo.getBoundingClientRect().y) + (this.gPointSize / 2))
            // console.log('jumpToX', jumpToX)
            // console.log('jumpToY', jumpToY)

            if (node.data.left) {
              // textWidth = (node.size[1] - xSpacing) >= this.textWidth ? this.textWidth : (node.size[1] - xSpacing)
              // textWidth = -textWidth
              // console.log('a gauche textWidth', Math.round(FindSource.getBoundingClientRect().width))
              jumpToX = jumpToX - (this.selectNodeCoords[0] + Math.round(FindSource.getBoundingClientRect().width))
              jumpToY = jumpToY - (this.selectNodeCoords[1] + Math.round(FindSource.getBoundingClientRect().height))
              // jumpToX = Math.round(jumpToX - (startX + FindSource.getBoundingClientRect().width))
              // jumpToY = Math.round(jumpToY - startY)
            } else {
              // jumpToX = Math.round(jumpToX)
              // jumpToY = (jumpToY - startY)
              jumpToX = jumpToX - this.selectNodeCoords[0]
              jumpToY = jumpToY - (this.selectNodeCoords[1] + Math.round(FindSource.getBoundingClientRect().height))
            }

            // console.log('selectNodeCoords', this.selectNodeCoords)
            // console.log('jumpToX', jumpToX + ' y'+jumpToY)
            const tran = d3.transition().duration(1000).ease(d3.easePoly)
            // console.log('node trouvé')
            d3.select(`path#jumpTo_${node.data.id}`)
            .transition(tran as any)
            .attr('d', pathJumpToBack(node, jumpToX, jumpToY))
            // console.log('se remet en position')
            // setTimeout(this.drawPathJump, 2000);
            
          }
        }
      }
    }
  }

  dragended(node: FlexNode, i: number, n: ArrayLike<Element>) {
    //  console.log('dragended node', node)
    if (this.editeMap) {
      const { dragback, reparent, fObjectClick } = this
      const draggedNode = n[i].parentNode as Element
      draggedNode.setAttribute('style', 'opacity: 1')
      const newParentNode = document.getElementById('newParentNode')
      // console.log('newParentNode', newParentNode)
      if (newParentNode) {
        const newParentD = d3.select(newParentNode).data()[0] as FlexNode
        // console.log('newParentD.data', newParentD.data)
        reparent(newParentD.data, node.data)
        // newParentNode.removeAttribute('id')
        // replace le bon id du node
        newParentNode.setAttribute('id', 'boxNode_' + newParentD.data.id)

        // il y a eu deplacement vers un autre noeud -> on met à jour en base
        this.moveNode(node.data, newParentD.data.dialog_node)
        // console.log('newParentD',newParentD.data)
        // recadre la vue mindmap
        if (this.autoScale) {
          this.fitContent()
        }
      } else {
        const LR = (node.data.id.split('-').length === 2) && ((node.y > 0 && node.y + node.py < 0) || (node.y < 0 && node.y + node.py > 0))
        // console.log('LR', LR)
        const flag = LR ? (a: FlexNode) => a.data.left !== node.data.left : (a: FlexNode) => a.data.left === node.data.left
        const draggedParentNode = d3.select(draggedNode.parentNode as Element)
        const draggedBrotherNodes = (draggedParentNode.selectAll(`g.depth_${node.depth}`) as d3.Selection<Element, FlexNode, Element, FlexNode>)
          .filter((a, i, n) => draggedNode !== n[i] && flag(a))

        // console.log('draggedBrotherNodes', draggedBrotherNodes)
        if (!draggedBrotherNodes.nodes()[0]) {
          if (LR) {
            this.move(node.data)
            // recadre la vue mindmap
            if (this.autoScale) {
              this.fitContent()
            }
          } else {
            // console.log('ca dragback1')
            dragback(node, draggedNode)
            fObjectClick(node, i, n)
          }
        } else {
          // console.log('draggedBrotherNodes')
          const a: { x0: number, x1: number, b1?: Mdata, n1?: Element, b0?: Mdata, n0?: Element } = { x0: Infinity, x1: -Infinity }
          draggedBrotherNodes.each((b, i, n) => {
            if (((b.x > node.x) || LR) && b.x > a.x1 && b.x < (node.x + node.px)) {
              a.x1 = b.x
              a.b1 = b.data
              a.n1 = n[i]
            }
            if (((b.x < node.x) || LR) && b.x < a.x0 && b.x > (node.x + node.px)) {
              a.x0 = b.x
              a.b0 = b.data
              a.n0 = n[i]
            }
          })
          if (a.b0 || a.b1) {
            const sdata = node.data
            if (a.b0 && a.n0) {
              this.move(sdata, a.b0)
              draggedNode.parentNode?.insertBefore(draggedNode, a.n0)
            } else if (a.b1 && a.n1) {
              this.move(sdata, a.b1, 1)
              draggedNode.parentNode?.insertBefore(draggedNode, a.n1.nextSibling)
            }
            // recadre la vue mindmap
            if (this.autoScale) {
              this.fitContent()
            }
          } else {
            // console.log('ca dragback2')
            dragback(node, draggedNode)
            fObjectClick(node, i, n)
          }
        }
      }
    }
    this.dragFlag = false
  }

  //--- multi selection de node ---//
  removeMultiSelected() {
    (this.mindmapG.selectAll('g.multiSelectedNode') as d3.Selection<Element, FlexNode, Element, FlexNode>)
      .each((d, i, n) => {
        // console.log('removeMultiSelected')
        n[i].classList.remove('multiSelectedNode')
      })
  }

  multiSelectStart() {
    // console.log('multiSelectStart')
    this.removeSelectedId()

    if (d3.event.button === 0) {
      this.removeMultiSelected()
      this.multiSeleFlag = true
      const { mouse, getViewPos } = this
      const vp = getViewPos()
      mouse.x0 = vp.left
      mouse.y0 = vp.top
    }
  }

  multiSelect() {
    if (this.multiSeleFlag) {
      // console.log('multiSelect', this.seleBox)
      this.showSelectedBox = true
      d3.event.preventDefault()
      const { mouse, getViewPos } = this
      const vp = getViewPos()
      mouse.x1 = vp.left
      mouse.y1 = vp.top
/*
      let rect = (this.$refs.content as SVGGElement).getBBox()
      let mindmapZoom = (rect.width * this.zoomNum)
      console.log('zoomNum', this.zoomNum)
      console.log('taille original de la mindmap:' + rect.width)
      console.log('taille zoomé de la mindmap:' + mindmapZoom)
      console.log('this.seleBox.width:' + this.seleBox.width)
      let calcZoomSelect = (this.seleBox.width * 100) / mindmapZoom
      // calcZoomSelect =calcZoomSelectcalcWidth/100
      console.log('calcZoomSelect %', calcZoomSelect)
      this.zoomSelect = (100 - calcZoomSelect) / 10
      console.log('zoomSelect %', this.zoomSelect)
*/

      // const { mindmapG, seleBox } = this
      // ;(mindmapG.selectAll('foreignObject.objectTextNode') as d3.Selection<Element, FlexNode, Element, FlexNode>)
      //   .each((d, i, n) => {
      //     const f = n[i]
      //     const g = (f.parentNode as Element)
      //     const pos = getViewPos(f.getBoundingClientRect())
      //     const flag = pos.left < seleBox.right && pos.bottom > seleBox.top && pos.right > seleBox.left && pos.top < seleBox.bottom
      //     if (flag) {
      //       g.classList.add('multiSelectedNode')
      //     } else {
      //       g.classList.remove('multiSelectedNode')
      //     }
      //   })

      // console.log('vp', vp)
      // console.log('mouse.x1' + mouse.x1 + ' : y1' + mouse.y1)

    }
  }
  async multiSelectEnd() {
    // console.log('multiSelectEnd')
    // console.log('mouse', this.mouse)
    this.multiSeleFlag = false
    this.showSelectedBox = false
    const { mouse } = this
    mouse.x0 = mouse.x1 = mouse.y0 = mouse.y1 = 0
  }

  //--- création de la carte mindmap ---//
  updateMindmap() {
    this.tree()
    this.getDTop()
    // this.draw()
    this.initNodeEvent()
  }

  //--- elements de la mindmap ---//
  dKey(d: FlexNode) { return d.data.gKey }
  gClass(d: FlexNode) { return `depth_${d.depth} node` }
  gTransform(node: FlexNode) {
    const { xSpacing } = this
    // console.log('gTransform node',node)
    let posY = node.dx
    let posX = node.dy >= (this.textWidth + xSpacing) ? (this.textWidth + xSpacing) : node.dy
    if (node.data.left) {
      // decale uniquement la generation 1 par rapport au node 0
      if (node.depth === 1) {
        if (node.parent) {
          posX = (posX - node.parent.data.size[1]) / 1.8
        }
      } else {
        posX = posX - xSpacing
      }
    } else {
      if (!node.data.generation) {
        posX = (node.data.size[1] / 2)
        this.decalageNode0 = posX
      }else {
        posX = posX + xSpacing
      }
    }
    return `translate(${posX},${posY})`
  }

  // calcule la position x de la box text title
  // foreignXTitle(node: FlexNode) {
  //   const { xSpacing, foreignBorderWidth } = this
  //   // pas plus de 300px de largeur
  //   let maxSizeWidth = node.size[1] >= (this.textWidth + xSpacing) ? (this.textWidth + xSpacing) : node.size[1]
  //   // console.log('node', node)
  //   // console.log('maxSizeWidth', maxSizeWidth)
  //   return -foreignBorderWidth + (node.depth ? (node.data.left ? -maxSizeWidth + xSpacing : 0) - 10 : -(maxSizeWidth - xSpacing * 2) / 2)
  // }

  // calcule la position X de la box text
  foreignX(node: FlexNode) {
    const { xSpacing, foreignBorderWidth, textWidth } = this
    if (!node.data.generation) {
      return -node.data.size[1]
    } else {
      let widthNode = (node.data.size[1] < node.data.optionSize[1]) ? node.data.optionSize[1] : node.data.size[1]
      // pas plus de 300px de largeur
      let maxSizeWidth = widthNode >= (textWidth + xSpacing) ? (textWidth + xSpacing) : widthNode

      return -foreignBorderWidth + (node.depth ? (node.data.left ? -maxSizeWidth + xSpacing : 0) : -(maxSizeWidth - xSpacing * 2) / 2)
    }
  }
  
  // foreignY(d: FlexNode) { return -this.foreignBorderWidth + (d.depth ? -d.size[0] : -d.size[0] / 2) }
  foreignY(node: FlexNode) {
    // pour les nodes cascade uniquement
    let decalageCascadeY = 0
    if (node.data.cascade && node.depth > 1) {
      decalageCascadeY = this.decalageNodeCascadeY
    } else if (node.data.cascade && node.depth === 1) {
      decalageCascadeY = (this.decalageNodeCascadeY)
    }
    return -this.foreignBorderWidth + (node.depth ? (-node.size[0] - 10) + decalageCascadeY : -node.size[0] / 2 )
  }
  
  // position du bouton add node
  gBtnTransform(node: FlexNode) {
    const { xSpacing, gBtnAddSize } = this
    let widthNode = (node.data.size[1] < node.data.optionSize[1]) ? node.data.optionSize[1] : node.data.size[1]
    let maxSizeWidth = widthNode >= (this.textWidth + xSpacing) ? (this.textWidth + xSpacing) : widthNode
    let x = !node.depth ? -node.data.size[1] : maxSizeWidth - xSpacing
    if (node.data.left) {
      x = -(x + xSpacing) - (gBtnAddSize - 2)
    }else if (!node.depth) {
      x = (x + xSpacing) + 12
    } else {
      x = (x + xSpacing) - 8
    }
    return `translate(${x},${-gBtnAddSize / 2 })`
  }

  // position de la boxnode
  gBoxnodeTransform(node: FlexNode) {

    // let maxSizeWidth = node.size[1] >= (this.textWidth + xSpacing) ? (this.textWidth + xSpacing) : node.size[1]
    // if (node.data.size[1] < node.data.optionSize[1]) {
    //   // console.log('path node option plus grand ', node.data.title)
    //   maxSizeWidth = node.data.optionSize[1] >= (this.textWidth + xSpacing) ? (this.textWidth + xSpacing) : node.data.optionSize[1]
    // }
    let x = 0
    if (node.data.left) {
      // x = -2
    }else if (!node.depth) {
      // x =  12
    } else {
      // if (node.parent && node.parent.data.size[1] < node.parent.data.optionSize[1]) {
      //   x = x + (node.parent.data.optionSize[1] - node.parent.data.size[1])
      // } else {
      //   // x = (x + xSpacing) - 8
      // }
    }
    return `translate(${x},0)`
  }

  
  // position du title jumpTo
  gJumpToTitleTransform(node: FlexNode) {
    // console.log('d.size[1]', d.size)
    const { xSpacing } = this
    let widthNode = (node.data.size[1] < node.data.optionSize[1]) ? node.data.optionSize[1] : node.data.size[1]
    let maxSizeWidth = widthNode >= (this.textWidth + xSpacing) ? (this.textWidth + xSpacing) : widthNode
    // console.log('gJumpToTitleTransform node', node)
    // console.log('maxSizeWidth', maxSizeWidth)
    let x = !node.depth ? -node.data.size[1] : maxSizeWidth - xSpacing
    // pour les nodes cascade uniquement
    let decalageCascadeY = 0
    if (node.data.cascade && node.depth >= 1) {
      decalageCascadeY = this.decalageNodeCascadeY
    }
    if (node.data.left) {
      // x = -(x + xSpacing + ((widthNode / 2) + this.widthJuptoText))
      x = -(x + xSpacing) - (40 + this.widthJuptoText)
    }else if (!node.depth) {
      x = (x + xSpacing) + 8
    } else {
      x = (x + xSpacing)
    }
    let posX = (x + 18)
    let posY =  -(node.size[0] / 1.5)
    return `translate(${posX},${posY + decalageCascadeY})`
  }


  // position du picto jumpTo
  gJumpToTransform(node: FlexNode) {
    // console.log('d.size[1]', d.size)
    const { xSpacing } = this
    let widthNode = (node.data.size[1] < node.data.optionSize[1]) ? node.data.optionSize[1] : node.data.size[1]
    let maxSizeWidth = widthNode >= (this.textWidth + xSpacing) ? (this.textWidth + xSpacing) : widthNode
    let x = !node.depth ? -node.data.size[1] : maxSizeWidth - xSpacing
    // pour les nodes cascade uniquement
    let decalageCascadeY = 0
    if (node.data.cascade && node.depth >= 1) {
      decalageCascadeY = this.decalageNodeCascadeY
    }
    if (node.data.left) {
      x = -(x + xSpacing) - this.gPointSize
    }else if (!node.depth) {
      x = (x + xSpacing) + 8
    } else {
      x = (x + xSpacing)
    }
    let posX = (x - 10)
    let posY =  -(node.size[0] / 2)
    return `translate(${posX},${posY + decalageCascadeY})`
  }

  // position du point node
  gPointTransform(node: FlexNode) {
    const { xSpacing } = this
    let widthNode = (node.data.size[1] < node.data.optionSize[1]) ? node.data.optionSize[1] : node.data.size[1]
    let maxSizeWidth = widthNode >= (this.textWidth + xSpacing) ? (this.textWidth + xSpacing) : widthNode
    let x = !node.depth ? (maxSizeWidth/2): maxSizeWidth - xSpacing
    // pour les nodes cascade uniquement
    let decalageCascadeY = 0
    if (node.data.cascade && node.depth >= 1) {
      decalageCascadeY = this.decalageNodeCascadeY
    }
    if (node.data.left) {
      x = -(x + xSpacing) - this.gPointSize
    }else if (!node.depth) {
      x =  (x - 2)
    } else {
      x = (x + xSpacing)
    }
    return `translate(${x}, ${decalageCascadeY})`
  }

  // position du bouton infos (!) node
  gInfosTransform(node: FlexNode) {
    // console.log('gInfosTransform', d)
    const { gBtnInfosSize, xSpacing, spaceNodePoint, textWidth } = this
    let widthNode = (node.data.size[1] < node.data.optionSize[1]) ? node.data.optionSize[1] : node.data.size[1]
    let maxSizeWidth = widthNode >= (textWidth + xSpacing) ? (textWidth + 44) : widthNode
    // pour les nodes cascade uniquement
    // let decalageCascadeY = 0
    // if (node.data.cascade && node.depth > 1) {
    //   decalageCascadeY = this.decalageNodeCascadeY
    // } else if (node.data.cascade && node.depth === 1) {
    //   decalageCascadeY = this.decalageNodeCascadeY + 16 // pour le 1er node cascade uniquement
    // }
    // console.log('bt info :', maxSizeWidth)
    let x = !node.depth ? -(node.data.size[1] / 2) : (maxSizeWidth - (maxSizeWidth + spaceNodePoint))
    let y = !node.depth ? - gBtnInfosSize / 1.9 : - gBtnInfosSize - 12 
    // console.log('bt info y:', y)
    if (!node.data.generation) {
      x = (x - 6)
    }else if (node.data.left) {
      x = (gBtnInfosSize  - (maxSizeWidth))
      y = (gBtnInfosSize - spaceNodePoint - 30)
    }
    return `translate(${x},${y})`
  }

  // position du bouton expand node
  gExpandTransform(node: FlexNode) {
    const { xSpacing, gBtnAddSize } = this
    let widthNode = (node.data.size[1] < node.data.optionSize[1]) ? node.data.optionSize[1] : node.data.size[1]
    let maxSizeWidth = widthNode >= (this.textWidth + xSpacing) ? (this.textWidth + xSpacing) : widthNode
    let x = !node.depth ? (maxSizeWidth/2) : maxSizeWidth - xSpacing
    // pour les nodes cascade uniquement
    let decalageCascadeY = 0
    if (node.data.cascade && node.depth >= 1) {
      decalageCascadeY = this.decalageNodeCascadeY
    }
    if (node.data.left) {
      x = -(x + xSpacing) - (gBtnAddSize - 2)
    }else if (!node.depth) {
      x = (x - 10)
    } else {
      x = (x + xSpacing) - 8
    }
    return `translate(${x},${(-gBtnAddSize / 2) + decalageCascadeY})`
  }
  // position du bouton collapse node
  gCollapseTransform(node: FlexNode) {
    const { xSpacing, gBtnAddSize } = this
    let widthNode = (node.data.size[1] < node.data.optionSize[1]) ? node.data.optionSize[1] : node.data.size[1]
    let maxSizeWidth = widthNode >= (this.textWidth + xSpacing) ? (this.textWidth + xSpacing) : widthNode
    let x = !node.depth ? (maxSizeWidth/2) : maxSizeWidth - xSpacing
    // pour les nodes cascade uniquement
    let decalageCascadeY = 0
    if (node.data.cascade && node.depth >= 1) {
      decalageCascadeY = this.decalageNodeCascadeY
    }
    if (node.data.left) {
      x = -(x + xSpacing) - (gBtnAddSize - 2)
    }else if (!node.depth) {
      x =  (x - 10)
    } else {
      x = (x + xSpacing) - 8
    }
    return `translate(${x},${(-gBtnAddSize / 2) + decalageCascadeY})`
  }

  // affiche un nom de class en fonction du node
  gClassNameForeignObject(node: FlexNode) {
    let className = 'objectTextNode'
    // si c'est le premier node
    if (node.data.generation === 0) {
      className = 'objectTextNode gen0'
    }
    if (node.data.cascade) {
      //bgColor = !d.depth ? 'white' : 'rgb(255 127 0 / 10%)'
      if (node.data.generation === 1) {
        className = 'objectCascade'
      }
    }
    return className
  }

  gJumpToTitle(d: FlexNode) {
    let title = 'inherit'
    console.log('gJumpToTitle', d)
    return title
  }

  // couleur de fond du text du node en fonction du type
  gBackgroundColorTypeNode(d: FlexNode) {
    // console.log('d.data.id :', d.data.id)
    return this.pathColor(d)
  }

  // affiche/cache le bouton infos
  gInfoBtnVisible(node: FlexNode) {
    return ((node.data._children?.length || 0) <= 0) ? 'visible' : 'visible' 
  }
  // affiche/cache le bouton edition
  gEditeBtnVisible(node: FlexNode) {
    return ((node.data._children?.length || 0) <= 0) ? 'visible' : 'visible' 
  }

  // affiche/cache le bouton jumpto
  gJumpToBtnVisible(node: FlexNode) {
    // uniquement si c'est le bouton add
    if (node.data.next_step && node.data.next_step.behavior == 'jump_to') {
      return ((node.data._children?.length || 0) <= 0) ? 'visible' : 'hidden' 
    } else {
      return 'hidden' 
    }
  }

  // faire la difference entre un jumpto dans l'arbo ou vers une escalade
  gJumpToIcone(node: FlexNode) {
    // console.log('this.arrayAllNodes', this.arrayAllNodes)
    // par defaut la flech
    let icone = 'M13.246,8.2v1.609h-2.413V8.2H8.823V6.592h2.011V1.767H5.205v4.825h2.01V8.2h-2.01v4.826h2.01v1.607h-2.01v4.825h5.629v-4.825H8.823v-1.607h2.011v-1.608h2.413v1.608h5.629V8.2H13.246z'
    // uniquement si c'est le bouton add
    if (node.data.next_step && node.data.next_step.behavior == 'jump_to') {
      this.arrayAllNodes.forEach((n:any) => {
        if (n.value === node.data.next_step.dialog_node) {
          // sinon marqueur de plan gps
          if (n.icone === 'location_on') {
            icone = 'M10.25,2c-3.317,0-6,2.683-6,6c0,4.5,6,11.143,6,11.143s6-6.643,6-11.143C16.249,4.683,13.566,2,10.25,2z M10.25,10.143 c-1.183,0-2.143-0.96-2.143-2.143s0.96-2.143,2.143-2.143S12.392,6.817,12.392,8S11.432,10.143,10.25,10.143z'
          }
        }
      })
    }
    return icone
  }

  // affiche/cache le bouton escalade
  gEscaladeBtnVisible(node: any) {
    // console.log('gEscaladeBtnVisible', node.data.output.targetfirst)
    // uniquement si c'est le bouton add
    if (node.data.output && node.data.output.targetfirst) {
      return ((node.data._children?.length || 0) <= 0) ? 'visible' : 'hidden' 
    } else {
      return 'hidden' 
    }
  }
  // affiche le bon icone pour l'escalade
  gEscaladeBtnIcone(node: any) {
    // console.log('node.data.output', node.data.output)
    let data = 'm0,0v0'
    // uniquement si c'est le bouton add
    if (typeof node.data.output.targetfirst !== 'undefined' && node.data.output.targetfirst) {
      // console.log('node.data.output.targetfirst', node.data.output.targetfirst)
      if (node.data.output.targetfirst.transfert) {
        data =  'M10.354,8.895c1.904,0,3.447-1.543,3.447-3.449c0-1.904-1.543-3.447-3.447-3.447c-1.905,0-3.448,1.543-3.448,3.447 C6.906,7.352,8.45,8.895,10.354,8.895z M10.354,10.619c-2.302,0-6.896,1.155-6.896,3.448v1.725H17.25v-1.725 C17.25,11.774,12.655,10.619,10.354,10.619z'
      } else if (node.data.output.targetfirst.meeting) {
        data =  'M13.838,10.932H9.967v3.871h3.871V10.932z M13.063,2.417v1.548H6.871V2.417H5.322v1.548H4.548 c-0.859,0-1.541,0.696-1.541,1.548L3,16.351c0,0.852,0.689,1.549,1.548,1.549h10.837c0.852,0,1.549-0.697,1.549-1.549V5.513 c0-0.852-0.697-1.548-1.549-1.548h-0.773V2.417H13.063z M15.386,16.351H4.548V7.835h10.837V16.351z'
      } else if (node.data.output.targetfirst.c2c) {
        data =  'M5.83,8.97c1.121,2.203,2.925,3.999,5.129,5.129l1.712-1.712c0.211-0.211,0.522-0.279,0.793-0.188 c0.872,0.288,1.813,0.444,2.778,0.444c0.429,0,0.779,0.35,0.779,0.779v2.715c0,0.428-0.351,0.778-0.779,0.778 c-7.307,0-13.229-5.922-13.229-13.23c0-0.428,0.35-0.778,0.779-0.778h2.724c0.427,0,0.777,0.351,0.777,0.778 c0,0.973,0.156,1.907,0.443,2.778C7.822,6.736,7.76,7.04,7.542,7.258L5.83,8.97z M16.367,3.444L15.815,2.9l-5.02,4.903V4.464h-0.778 v4.67h4.669V8.355h-3.229L16.367,3.444z'
      } else if (node.data.output.targetfirst.form) {
        data =  'M16.297,3.575H3.922c-0.851,0-1.539,0.696-1.539,1.547l-0.008,9.281c0,0.851,0.696,1.547,1.547,1.547h12.375 c0.851,0,1.547-0.696,1.547-1.547V5.122C17.844,4.271,17.147,3.575,16.297,3.575z M16.297,6.669l-6.188,3.867L3.922,6.669V5.122 l6.188,3.867l6.188-3.867V6.669z'
      }
    }
    return data
  }
  // affiche le bon icone pour l'escalade
  gEscaladebackgroundColor(node: FlexNode) {
    // console.log('gEscaladebackgroundColor node', node)
    let color = '#ff7f00' // orange
    if (node.data.next_step && node.data.next_step.behavior == 'jump_to') {
      color = '#ff7f00' // orange
    // ou bien si c'est un transfert
    } else if (node.data.output && node.data.output.targetfirst) {
      color = '#b2df8a' // vert
    }
    return color
  }

  // opacité des node technique en mode editione
  gOpacityNode (node: FlexNode) {
    if ((node.data.private || node.data.cascade) && !this.editeMap) {
      return '1' 
    } else {
      return '1'
    }
  }

  // affiche/cache le node technique
  gDisplayNode(node: FlexNode) {
    // uniquement si c'est un node private
    if (node.data.private) {
      // si c'est un jumpto ou cascade
      if(node.data.cascade) {
        if (this.switchJumpTo) {
          return 'block' 
        } else {
          return 'none'
        }
      // si c'est un dossier faq
      } else if (node.data.folder) {
          if(this.switchDossier) {
            return 'block'
          } else {
            return 'none'
          }
      // si c'est une branche technique
      } else if (node.data.technic) {
        if (this.switchTechnique) {
          return 'block'
        } else {
          return 'none'
        }
      } else {
        if(this.switchDossier) {
          // console.log('node', node)
          if (node.data.type === 'faq') {
            return 'block'
          } else {
            return 'none'
          }
        }
        return 'none'
        // sinon il faut regarder si le parent est visible pour afficher l'enfant
        // let display = 'none'
        // const {mindmapG} = this
        // mindmapG.select('#'+node.data.parent)
        // .each((xNode:any) => {
        //   // console.log('je suis ce node', node.data.dialog_node)
        //   if (xNode.depth && xNode.data.folder && this.switchDossier) {
        //     node.data.folder = 1 // c'est donc aussi un folder(faq)
        //     // console.log('mon parent est bien un folder', xNode.data.dialog_node)
        //     display = 'block'
        //   }
        // })
        // return display
      }
    } else {
      return 'block'
    }
  }

  // affichage des nodes jumto
  // affiche/cache le titre du lien vers un jumpto
  gDisplayNodeJumpTo(node: FlexNode) {
    // console.log('gDisplayNodeJumpTo', node)
    // uniquement si c'est un jumpto ou un transfert
    if (node.data.next_step.dialog_node || node.data.output.targetfirst) {
      return 'block'
    } else {
      return 'none'
    }
  }


  // recherche et affiche le bon titre du jumpto
  gDisplayTitleJumpTo(node: FlexNode) {
    // console.log('gDisplayTitleJumpTo', node)
    // console.log('node.data.next_step', node.data.next_step)
    let title = ''
    // uniquement si c'est un jumpto
    if (node.data.next_step && node.data.next_step.behavior == 'jump_to') {
      let nodeId = node.data.next_step.dialog_node
      // console.log('this.arrayAllNodes', this.arrayAllNodes)
      if (this.arrayAllNodes.length) {
        this.arrayAllNodes.forEach((child:any) => {
          // console.log('index', index)
          // console.log('child', child.value)
          if (child.value === nodeId ) {
            // console.log('child.title', child.title)
            title = child.name
          }
        })
      }
    // ou bien si c'est un transfert
    } else if (node.data.output && node.data.output.targetfirst) {
      if (node.data.output.targetfirst.transfert) {
        title = 'Transfert vers un conseiller'
      } else if (node.data.output.targetfirst.meeting) {
        title = 'Prendre un rendez-vous'
      } else if (node.data.output.targetfirst.c2c) {
        title = 'Proposer un callback'
      } else if (node.data.output.targetfirst.form) {
        title = 'Formulaire de contact'
      }
    }
    // console.log('gDisplayTitleJumpTo', title)
    return String(title)
  }

  // affiche/cache le node 0
  gDisplayNodeZero(node: FlexNode) {
    // uniquement si c'est un node 0
    if (!node.data.generation && node.data.cascade) {
      return 'none'
    } else {
      return 'block'
    }
  }

  // affiche/cache le tittre si identique au conditionsLabel
  gDisplayNodeTitle(node: FlexNode) {
    // uniquement si c'est un node 0
    if (node.data.title == node.data.conditionsLabel || node.data.id == '0') {
      return 'none'
    } else {
      return 'block'
    }
  }

  gDisplayBoxNode(node: FlexNode) {
    // uniquement si c'est un node 0
    if (node.data.generation && !node.data.cascade) {
      return 'block'
    } else if (!node.data.generation && node.data.cascade) {
      return 'none'
    } else {
      return 'block'
    }
  }

  // affiche/cache le point
  gDisplayNodePointZero(node: FlexNode) {
    // uniquement si c'est un node 0
    if (node.data.id == '0') {
      return 'none'
    } else {
// il faudrait ajouter ici un test si node type text pour ne pas afficher le point si type text
      return 'block'
    }
  }

  // affiche/cache le bouton add node
  gBtnAddVisible(node: FlexNode) {
    // uniquement si c'est le bouton add
    if (node.data.next_step && node.data.next_step.behavior == 'jump_to') {
      return 'hidden' 
    } else {
      return ((node.data._children?.length || 0) <= 0) ? 'visible' : 'hidden' 
    }
  }
  gEllTransform(node: FlexNode) {
    const { xSpacing } = this
    let widthNode = (node.data.size[1] < node.data.optionSize[1]) ? node.data.optionSize[1] : node.data.size[1]
    let maxSizeWidth = widthNode >= (this.textWidth + xSpacing) ? (this.textWidth + xSpacing) : widthNode
    let x = !node.depth ? 8 : maxSizeWidth - xSpacing + 10
    let decalageCascadeY = 0
    if (node.data.cascade && node.depth >= 1) {
      decalageCascadeY = this.decalageNodeCascadeY
    }
    if (node.data.left) {
      x = -(x + xSpacing + 32)
    } else {
      x = x + xSpacing
    }
    return `translate(${x},${(0 + decalageCascadeY)})`
  }
  // affiche/cache le bouton expande nodes
  gBtnExpandVisible(node: FlexNode) {
    // toujours caché sauf si mouseOver
    return (node.data._children?.length || 0) > 0 ? 'visible' : 'hidden' 
  }
  // affiche/cache le bouton collapse nodes
  gBtnCollapseVisible(node: FlexNode) {
    // toujours caché sauf si mouseOver
    return (node.data.children?.length || 0) > 0 ? 'visible' : 'hidden' 
  }
  gEllVisible(node: FlexNode) {
    return (node.data._children?.length || 0) > 0 ? 'visible' : 'hidden' 
  }

  // cascadeNodeX(node: FlexNode) {
  //   let widthNode = (node.data.size[1] < node.data.optionSize[1]) ? node.data.optionSize[1] : node.data.size[1]
  //   if (node.data.id == '0'){
  //     const { xSpacing, foreignBorderWidth } = this
  //     // pas plus de 300px de largeur
  //     let maxSizeWidth = widthNode >= (this.textWidth + xSpacing) ? (this.textWidth + xSpacing) : widthNode
  //     return -foreignBorderWidth - (maxSizeWidth - xSpacing * 2) / 2
  //   } else {
  //      if (node.data.left) {
  //       // return -foreignBorderWidth -(maxSizeWidth - xSpacing * 2) / 2
  //       let maxSizeWidth = widthNode >= (this.textWidth + this.xSpacing) ? (this.textWidth + this.xSpacing) : widthNode
  //       return -this.foreignBorderWidth - (maxSizeWidth + widthNode ) 
  //     } else{
  //       return 10
  //     }
      
  //   }
  // }

  labelPosX(node: FlexNode) {
    // console.log('labelPosX node', node)
    let posXNode = 0
    let widthNode = (node.data.size[1] < node.data.optionSize[1]) ? node.data.optionSize[1] : node.data.size[1]
    let maxSizeWidth = widthNode >= (this.textWidth + this.xSpacing) ? (this.textWidth + this.xSpacing) : widthNode
    if (node.data.left) {
      // posXNode = - (node.data.optionSize[1] - this.minTextWidth)
      posXNode = -(maxSizeWidth - 40 ) 
    } else if (!node.data.generation) {
      posXNode = -((maxSizeWidth/2) - 14)
    }
    return posXNode
  }

  boxNodeX(node: FlexNode) {
    let posXNode = 0
    let widthNode = (node.data.size[1] < node.data.optionSize[1]) ? node.data.optionSize[1] : node.data.size[1]
    let maxSizeWidth = widthNode >= (this.textWidth + this.xSpacing) ? (this.textWidth + this.xSpacing) : widthNode
    if (!node.data.generation) {
      posXNode = -(maxSizeWidth/2)
    } else {
       if (node.data.left) {
        // return -foreignBorderWidth -(maxSizeWidth - xSpacing * 2) / 2
        posXNode = -this.foreignBorderWidth - (maxSizeWidth - 20 ) 

      } else{
        posXNode = -8
        // return -10
      }
    }
    return posXNode
  }


  boxNodeY(node: FlexNode) {
    if (node.data.id == '0'){
      return -13
    } else {
      return -54
    }
  }

  boxNodeWidth(node: FlexNode) {
    // console.log('boxNodeWidth node', node.data.title)
    // console.log('boxNodeWidth nodeTextWidth', nodeTextWidth)
    // compare la longeur du text de l'option et celle du titre
    // console.log('node.data.size[1]', node.data.size[1])
    // console.log('node.data.optionSize[1]', node.data.optionSize[1])
    let widthNode = (node.data.size[1] < node.data.optionSize[1]) ? node.data.optionSize[1] : node.data.size[1]

    if (widthNode > (this.textWidth + this.xSpacing)) {
      widthNode = (this.textWidth + this.xSpacing)
    }
    // si node 0
    if (!node.data.generation) {
      widthNode = widthNode - 20
    }
    //   console.log('boxNodeWidth 0:', widthNode)
    // }
    // retourne la bonne largeur
    
    return widthNode
  }

  optionWidth(node: FlexNode) {
    // console.log('optionWidth node ', node)
    // console.log('optionWidth nodeTextWidth ', nodeTextWidth)
    let widthNode = (node.data.optionSize[1] / 1) - (this.spaceNodePoint + this.minTextWidth)
    const lengthTitle:number = node.data.title.length
    const lengthLabel:number = node.data.conditionsLabel ? node.data.conditionsLabel.length : node.data.title.length

    if (widthNode >= (this.textWidth + this.xSpacing)) {
      widthNode = (this.textWidth + this.spaceNodePoint)
    }
    // console.log('titre plus ', node.data.title)
    // console.log('titre plus data', node.data)
    if (node.data.left && lengthTitle >= lengthLabel) {
      // console.log('titre plus grand', node.data.title)
      widthNode = node.data.size[1] - (this.spaceNodePoint + this.minTextWidth)
    }
    // si node 0 uniquement prendre la taille du title et pas de l'option
    if (!node.data.generation) {
      widthNode = node.data.size[1] - (this.spaceNodePoint + this.minTextWidth)
      // console.log('le noeud zéro', widthNode)
    }
    // uniquement pour l'affichage des escalades seul
    if (node.data.cascade && !node.data.left) {
      // console.log('node zero', node.data.title)
      widthNode = node.data.size[1] - (this.spaceNodePoint + this.minTextWidth)
    }
    // retourne la bonne largeur
    // console.log('largeur option ', node.data.title)
    // console.log('node width :', widthNode)
    return widthNode
  }

  boxNodeHeight(node: FlexNode) {
    // si node 0
    if (node.data.id == '0') {
      return 31
    } else {
      return 50
    }
  }

  // path entre node classic
  pathId(node: FlexNode) {
    return `path_${node.data.id}`
  }
  pathClassNode(node: FlexNode) {
    return `depth_${node.depth} pathNode`
  }
  pathClassJumpto(node: FlexNode) {
    return `depth_${node.depth} pathJumpto`
  }
  pathColor(node: FlexNode) {
    return node.data.color || 'grey'
  }


  path(node: FlexNode) {
    // console.log('path node', node.data.title)
    // console.log('node.data.size[1]', node.data.size[1])
    // console.log('node.data.optionSize[1]', node.data.optionSize[1])
    const { xSpacing, link } = this
    let widthNode = (node.data.size[1] <= node.data.optionSize[1]) ? node.data.optionSize[1] : node.data.size[1]
    const temp = (node.parent && node.parent.data.id === '0') ? -xSpacing : (node.data.left ? xSpacing : -xSpacing)
    // console.log('temp', temp)
    let sourceX = temp - node.py
    let sourceY = 0 - node.dx - node.px
    let targetX = 0
    let targetY = 0
    // console.log('path node ', node)
    // let textWidth = (d.size[1] - xSpacing) <= this.textWidth ? d.size[1] - xSpacing : this.textWidth
    let textWidth = widthNode  > (this.textWidth + xSpacing) ? (this.textWidth + xSpacing) : widthNode
    // console.log('path textWidth ', textWidth)
    
    // compare la largeur du tittre et du label
    // le titre est 2 fois plus petite en largeur
    // const lengthTitle:number = node.data.title.length
    // const lengthLabel:number = node.data.conditionsLabel ? node.data.conditionsLabel.length : 0
    // // si le titre est plus petit que le label
    // if (lengthTitle > lengthLabel) {
    //   if (lengthTitle < this.textWidth) {
    //     textWidth = textWidth / 1
    //   } else {
    //     textWidth = (this.textWidth + this.spaceNodePoint)
    //   }
    // }
    

    // console.log('path : ', textWidth)
    // pour le coté gauche uniquement
    if (node.data.left) {
      textWidth = -textWidth
    // } else {
    //   textWidth = (textWidth + xSpacing)
    }
    // console.log('textWidth', textWidth)
    // uniquement pour les node escamade
    let decalageCascadeY = 0
    if (node.data.cascade) {
      decalageCascadeY = this.decalageNodeCascadeY
      if (node.depth === 1) {
        // console.log('path node ', node)
        // console.log('cascade', `${link({ source: [sourceX , sourceY], target: [0, 0] })}L${textWidth},${0}`)
        return `${link({ source: [0 , (0 + decalageCascadeY)], target: [targetX, (targetY + decalageCascadeY)] })}L${textWidth}, ${(0 + decalageCascadeY)}`
      } else {
        return `${link({ source: [sourceX , (sourceY + decalageCascadeY)], target: [targetX, (targetY + decalageCascadeY)] })}L${textWidth}, ${(0 + decalageCascadeY)}`
      }
    } else {
      // if(node.parent && node.parent.data.id === '0') {
        return `${link({ source: [sourceX, sourceY], target: [targetX, targetY] })}L${textWidth}, ${0}`
        // return `${link({ source: [-10 , 0], target: [0, 0] })}L${textWidth},${0}`
      // } else {
      //   return `${link({ source: [sourceX, sourceY], target: [targetX, targetY] })}L${textWidth}, ${0}`
      // }
    }
  }

  //----------- pour les jump to a finir -----------------------------//
  pathJumpToBack(node: FlexNode, px: number, py: number,) {
    const { xSpacing, linkJumpTo } = this
    let widthNode = (node.data.size[1] < node.data.optionSize[1]) ? node.data.optionSize[1] : node.data.size[1]
    let textWidth = widthNode >= (this.textWidth + xSpacing) ? (this.textWidth + xSpacing) : (widthNode - xSpacing)
    // compare la largeur du tittre et du label
    // le titre est 2 fois plus petite en largeur
    const lengthTitle:number = node.data.title.length
    const lengthLabel:number = node.data.conditionsLabel ? node.data.conditionsLabel.length : node.data.title.length
    // si le titre est plus petit que le label
    if (lengthTitle > lengthLabel) {
      if (lengthTitle < this.textWidth) {
        textWidth = textWidth / 1
      } else {
        textWidth = (this.textWidth + this.spaceNodePoint)
      }
    }
    // let objectDataNode:any
    // objectDataNode = node.data
    if (node.data.left) {
      textWidth = (widthNode - xSpacing) >= this.textWidth ? (this.textWidth + xSpacing) : widthNode
      textWidth = -(textWidth + xSpacing + this.gPointSize)
      // textWidth = -(textWidth + xSpacing)
    }
    // console.log('pathJumpToMove', node)
    return `${linkJumpTo({ 
            source: [px / this.zoomNum, py / this.zoomNum],
            target: [textWidth + xSpacing, 0] 
            })
          }`
  }

  // path jump to en deplacement
  pathJumpToMove(node: FlexNode) {
    const { xSpacing, linkJumpTo } = this
    let widthNode = (node.data.size[1] < node.data.optionSize[1]) ? node.data.optionSize[1] : node.data.size[1]
    let textWidth = widthNode >= (this.textWidth + xSpacing) ? (this.textWidth + xSpacing): (widthNode - xSpacing)
    // compare la largeur du tittre et du label
    // le titre est 2 fois plus petite en largeur
    const lengthTitle:number = node.data.title.length
    const lengthLabel:number = node.data.conditionsLabel ? node.data.conditionsLabel.length : node.data.title.length
    // si le titre est plus petit que le label
    if (lengthTitle > lengthLabel) {
      if (lengthTitle < this.textWidth) {
        textWidth = textWidth / 1
      } else {
        textWidth = (this.textWidth + this.spaceNodePoint)
      }
    }
    let objectDataNode:any
    objectDataNode = node.data
    // console.log('pathJumpToMove', node)
    // si c'est un jump to
    if(objectDataNode.next_step && objectDataNode.next_step.behavior == 'jump_to') {
      // let nodeName = d.data.next_step
      // console.log('next_step',objectDataNode.next_step.dialog_node)
      let FindSource:any = document.getElementById(node.data.dialog_node)
      let FindJumpTo:any = document.getElementById('point_' + objectDataNode.next_step.dialog_node)


      // si il existe un node pour jump to
      if (FindJumpTo) {
        // console.log('trouvé source', FindSource.getBoundingClientRect())
        // console.log('trouvé cible', FindJumpTo.getBoundingClientRect())
        
        let startX = Math.round(FindSource.getBoundingClientRect().x)
        let startY = Math.round(FindSource.getBoundingClientRect().y)
        // console.log('startX', startX)
        // console.log('startY', startY)
        

        let jumpToX = (Math.round(FindJumpTo.getBoundingClientRect().x) + (this.gPointSize / 2))
        let jumpToY = (Math.round(FindJumpTo.getBoundingClientRect().y) + (this.gPointSize / 2))
        // console.log('jumpToX', jumpToX)
        // console.log('jumpToY', jumpToY)

        // console.log('path : ', textWidth)
        // pour le coté gauche uniquement
        if (node.data.left) {
          textWidth = (widthNode - xSpacing) >= this.textWidth ? (this.textWidth + xSpacing) : widthNode
          textWidth = -(textWidth + xSpacing + this.gPointSize)
          // console.log('a gauche textWidth', Math.round(FindSource.getBoundingClientRect().width))
          jumpToX = jumpToX - (startX + Math.round(FindSource.getBoundingClientRect().width))
          jumpToY = jumpToY - (startY + Math.round(FindSource.getBoundingClientRect().height))
          // jumpToX = Math.round(jumpToX - (startX + FindSource.getBoundingClientRect().width))
          // jumpToY = Math.round(jumpToY - startY)
          // console.log('a gauche', jumpToX)
        } else {
          
          // jumpToX = Math.round(jumpToX)
          // jumpToY = (jumpToY - startY)
          jumpToX = jumpToX - (startX)
          jumpToY = jumpToY - (startY + Math.round(FindSource.getBoundingClientRect().height))
          // console.log('a droite', jumpToX)
        }
        // console.log('jumpToX', jumpToX)
        // console.log('jumpTo', {source: [startX, startY], target: [jumpToX, jumpToY]})

        // return `${link({ source: [sourceX, sourceY], target: [x, y] })}L${textWidth},${0}`
        // il faut applique le coef du zoom
        return `${linkJumpTo({ 
          source: [jumpToX / this.zoomNum, jumpToY / this.zoomNum],
          target: [textWidth + xSpacing, 0] 
          })
        }`
      }
    }
    return `${linkJumpTo({ source: [0, 0], target: [0, 0] })}`
  }
  // path jump to
  pathJumpTo(node: FlexNode) {
    const { xSpacing, linkJumpTo } = this
    let widthNode = (node.data.size[1] < node.data.optionSize[1]) ? node.data.optionSize[1] : node.data.size[1]
    let objectDataNode:any
    objectDataNode = node.data
    // console.log('pathJumpTo', node)
    // si c'est un jump to
    if(objectDataNode.next_step && objectDataNode.next_step.behavior == 'jump_to') {
      // let nodeName = d.data.next_step
      // console.log('next_step -->',objectDataNode.next_step.dialog_node)
      let FindSource:any = document.getElementById(node.data.dialog_node)
      let FindJumpTo:any = document.getElementById('point_' + objectDataNode.next_step.dialog_node)
      // console.log('FindJumpTo', FindJumpTo.getBoundingClientRect())
      // si il existe un node pour jump to
      if (FindJumpTo) {
        // console.log('trouvé', FindSource.getBoundingClientRect())
        let jumpToX = (Math.round(FindJumpTo.getBoundingClientRect().x) + (this.gPointSize / 2))
        let jumpToY = (Math.round(FindJumpTo.getBoundingClientRect().y) + (this.gPointSize / 2))

        let startX = Math.round(FindSource.getBoundingClientRect().x)
        let startY = Math.round(FindSource.getBoundingClientRect().y)

        // let textWidth = (d.size[1] - xSpacing) <= this.textWidth ? d.size[1] - xSpacing : this.textWidth
        let textWidth = widthNode - xSpacing >= this.textWidth ? this.textWidth : (widthNode - xSpacing)
        // compare la largeur du tittre et du label
        // le titre est 2 fois plus petite en largeur
        const lengthTitle:number = node.data.title.length
        const lengthLabel:number = node.data.conditionsLabel ? node.data.conditionsLabel.length : node.data.title.length
        // si le titre est plus petit que le label
        if (lengthTitle > lengthLabel) {
          if (lengthTitle < this.textWidth) {
            textWidth = textWidth / 1
          } else {
            textWidth = (this.textWidth + this.spaceNodePoint)
          }
        }
        // console.log('path : ', textWidth)
        // pour le coté gauche uniquement
        if (node.data.left) {
          textWidth = (widthNode - xSpacing) >= this.textWidth ? (this.textWidth + xSpacing) : widthNode
          textWidth = -(textWidth + xSpacing + this.gPointSize)
          // console.log('textWidth', textWidth)
          jumpToX = Math.round(jumpToX - (startX - textWidth) )
          jumpToY = Math.round(jumpToY - (startY + node.data.size[0]))
          // jumpToX = (jumpToX - startX + textWidth)
          // jumpToY = (jumpToY - startY)
        } else {
          jumpToX = Math.round(jumpToX - startX )
          jumpToY = Math.round(jumpToY - (startY + node.data.size[0]) )
          // jumpToX = (jumpToX - startX)
          // jumpToY = (jumpToY - startY)
        }
        // console.log('jumpTo', {source: [textWidth, 0], target: [jumpToX, jumpToY]})
        // console.log('pathJumpTo --> jumpToX:'+ jumpToX +' jumpToY:'+jumpToY)
        // return `${link({ source: [sourceX, sourceY], target: [x, y] })}L${textWidth},${0}`
        return `${linkJumpTo({ 
          source: [jumpToX, jumpToY],
          target: [textWidth + xSpacing, 0] 
          })
        }`
      }
    }
    // return false
    return `${linkJumpTo({ source: [0, 0], target: [0, 0] })}`
  }
  rotateIcone(node: FlexNode) {
    if (node.data.left) {
      return 'rotate(-180 8 8.321)'
    } else {
      return 'rotate(0 6.7795 8.321)'
    }
  }
  // path en pontillé
  pathStroke(node: FlexNode) {
    let objectDataNode:any
    let style = ''
    objectDataNode = node.data
    // console.log('pathJumpTo', node)
    // si c'est un jump to
    if(objectDataNode.private) {
      style = 'stroke-dasharray: 4 8;'
    }
    return style
  }

  // id de l'element svg g
  gPathId(node: FlexNode) {
    return `g_${node.data.id}`
  }

  // path id pour jump to
  pathIdJumpTo(node: FlexNode) {
    let name
    // console.log('pathIdJumpTo', node.data.next_step)
    if (node.data.next_step && node.data.next_step.behavior == 'jump_to') {
      // c'est bien un path jumpTo qu'il faut garder
      name = `jumpTo_${node.data.id}`
    } else {
      // marque ce path comme inutil pour etre effacé plus tard a l'update du mindmap
      name = `noPathJump_${node.data.id}`
    }
    // console.log('name', name)
    return name
  }

  // path id pour les boxNode
  pathIdBoxNode(node: FlexNode) {
    return `boxNode_${node.data.id}`
  }
  
  pathJumpToColor() { 
    return '#999999' || 'gray'
  }

  nest(node: FlexNode, i: number, n: ArrayLike<Element>) {
    // console.log('nest')
    const { dKey, appendNode, updateNode, exitNode } = this
    const child = node.children || [];
    (d3.select(n[i]).selectAll(`g${child[0] ? `.depth_${child[0].depth}.node` : ''}`) as d3.Selection<Element, FlexNode, Element, FlexNode>)
      .data(child, dKey)
      .join(appendNode, updateNode, exitNode)
  }

  //--- ajouter un element svg ---//
  appendNode(enter: d3.Selection<d3.EnterElement, FlexNode, Element, FlexNode>) {
    // console.log('appendNode')
    const {
      gOpacityNode,
      gJumpToTransform,
      gDisplayNode,
      gDisplayNodeZero,
      gDisplayNodeTitle,
      gDisplayBoxNode,
      // gDisplayNodePointZero,
      gJumpToBtnVisible,
      gJumpToIcone,
      gEscaladeBtnVisible,
      gEscaladeBtnIcone,
      pathIdJumpTo,
      pathJumpToColor,
      // pathJumpTo,
      expand,
      gExpandTransform,
      gEllTransform,
      gClass,
      gPointTransform,
      gBoxnodeTransform,
      gTransform,
      updateNodeName,
      divKeyDown,
      foreignY,
      // gBtnTransform,
      gInfosTransform,
      pathId,
      pathClassNode,
      pathClassJumpto,
      pathColor,
      path,
      nest,
      fdivMouseDown,
      // foreignXTitle,
      foreignX,
      gBtnAddSize,
      gBtnInfosSize,
      gInfoBtnVisible,
      gBackgroundColorTypeNode,
      gClassNameForeignObject,
      gDisplayNodeJumpTo,
      gJumpToTitleTransform,
      gDisplayTitleJumpTo,
      boxNodeWidth,
      boxNodeHeight,
      optionWidth,
      labelPosX,
      // gJumpToTitle,
      // gBtnAddVisible,
      rotateIcone,
      gEllVisible,
      gBtnExpandVisible,
      gBtnCollapseVisible,
      gCollapseTransform,
      collapse,
      gEditeBtnVisible,
      spaceNodePoint,
      // gEditTransform,
      gEscaladebackgroundColor,
      boxNodeX,
      // cascadeNodeX,
      boxNodeY,
      gPathId
    } = this
    const gNode = enter.append('g')
      .attr('id', gPathId)
      .attr('class', gClass)
      .attr('transform', gTransform)
      .style('display', gDisplayNode)
      .style('opacity', gOpacityNode)


    // affiche un point pour indiquer le point de depart du path
    const point = gNode.append('g')
      .attr('class', 'gPoint')
      .style('display', gDisplayNodeZero)
      .attr('transform', gPointTransform)
      .attr('id',(d: FlexNode) => d.data.dialog_node ? String('point_' + d.data.dialog_node) : String('point_' + d.data.id))
    point.append('circle')
      .attr('cx', 0)
      .attr('cy', 0)
      .attr('r', this.gPointSize)
      .attr('fill', pathColor)

    // console.log('append node ', enter )
    // le conteneur boxNode
    // const boxNode = gNode.append('g')
    //   .style('display', gDisplayBoxNode)
    //   .attr('class', 'boxNode')
    //   .attr('left', (d: FlexNode) => d.data.left ? 'true' : 'false')
    //   .attr('id',(d: FlexNode) => d.data.id ? String('boxNode_' + d.data.id) : String('boxNode_' + d.data.id))

    let boxNode = gNode.append('g')
      .style('display', gDisplayBoxNode)
      .attr('class', 'boxNode')
      .attr('left', (d: FlexNode) => d.data.left ? 'true' : 'false')
      .attr('transform', gBoxnodeTransform)
      .attr('id',(d: FlexNode) => d.data.id ? String('boxNode_' + d.data.id) : String('boxNode_' + d.data.id))
      // .style('border', (d: FlexNode) => d.data.id ? '1px solid #0f0' : '3px solid #0f0')
      
    const boxNodeText = boxNode.append('rect')
      .attr('class', 'boxNodeRect')
      .attr('height', boxNodeHeight)
      // .style('border', '1px solid #0f0')
      .attr('rx', 8)
      .attr('ry', 8)

    // ---- le Titre ---- //
    // le conteneur du titre
    const foreignTitre = boxNode.append('foreignObject')
      .attr('x', foreignX)
      .attr('y', foreignY)
      // .style('border', '1px solid #00f')
      .attr('class', 'boxLabel')
      .attr('left', (d: FlexNode) => d.data.left ? 'true' : 'false')
      .attr('id',(d: FlexNode) => d.data.dialog_node ? String('titleNode_' + d.data.id) : String('titleNode_' + d.data.id))
      // .style('background-color', gBackgroundColorTypeNode)

    // console.log('foreignDiv')
    const foreignTitreDiv = foreignTitre.append('xhtml:div')
      .attr('class', 'titleNode')
      .style('display', gDisplayNodeTitle)
      .text((d: FlexNode) => d.data.title ? '#' + d.data.title : String('#' + d.data.title)) // si pas de title on affiche pas
    
    // console.log('foreignDiv', foreignDiv)
    foreignTitreDiv.on('blur', updateNodeName).on('keydown', divKeyDown).on('mousedown', fdivMouseDown)
    foreignTitreDiv.each((d, i, n) => {
      const observer = new ResizeObserver((l) => {
        const t = l[0].target
        // console.log('l', l[0])
        const b1 = getComputedStyle(t).borderTopWidth
        const b2 = getComputedStyle(t.parentNode as Element).borderTopWidth
        const spacing = (parseInt(b1, 10) + parseInt(b2, 10)) || 0
        let calcWidth = (l[0].contentRect.width + spacing * 2) + spaceNodePoint
        if(calcWidth <= 60 && !d.depth) {
          calcWidth = 60 + spaceNodePoint
        }
        // let textWidth = calcWidth >= this.textWidth ? (this.textWidth) : (calcWidth)
        // console.log('textWidth', textWidth)
        
        foreignTitre.filter((d: FlexNode, index: number) => i === index)
          // .attr('width', textWidth + 2)// div和foreign border
          .attr('height', l[0].contentRect.height + spacing * 2)
          // .style('width', textWidth + 2)
          .style('font-size', '8px')
          // .style('border', '1px solid #00f')
          .attr('y', -54)
          // .attr('x', labelPosX(d, textWidth))
          .attr('width', boxNodeWidth(d) - 40)
          .style('width', boxNodeWidth(d) - 40)
      })
      observer.observe(n[i] as Element)
      // console.log('observer', observer)
    })

    // ----- le label (nom de l'option par exemple) ---- //
    // le conteneur du label
    const foreignLabel = gNode.append('foreignObject')
      .attr('x', foreignX)
      .attr('y', foreignY)
      .style('display', gDisplayNodeZero)
      // .style('border', '1px solid #0ff')
      .attr('class', gClassNameForeignObject)
      .attr('left', (d: FlexNode) => d.data.left ? 'true' : 'false')
      .attr('id',(d: FlexNode) => d.data.dialog_node ? String(d.data.dialog_node) : String(d.data.id))
      

    // console.log('foreignLabelDiv')
    const foreignLabelDiv = foreignLabel.append('xhtml:div')
      .attr('class', 'labelNode')
      .attr('contenteditable', false)
      .style('background-color', gBackgroundColorTypeNode)
      // .text((d: FlexNode) => d.data.conditionsLabel ? d.data.conditionsLabel : String(d.data.title)) // si pas de label on prend le title
      .text((d: FlexNode) => !d.data.generation ? String(d.data.title) : d.data.conditionsLabel ? d.data.conditionsLabel : String(d.data.title)) // si pas de label on prend le title
    
    // console.log('foreignLabelDiv', foreignLabelDiv)
    foreignLabelDiv.on('blur', updateNodeName).on('keydown', divKeyDown).on('mousedown', fdivMouseDown)
    foreignLabelDiv.each((d: FlexNode, idx: number, n) => {
      // console.log('n', n)
      const observer = new ResizeObserver(() => {
        if (d.depth) {
          foreignLabel.filter((d: FlexNode, index: number) => idx === index)
          .attr('x', 0)
        }
        foreignLabel.filter((d: FlexNode, index: number) => idx === index)
          .attr('height', 30)
          .attr('x', labelPosX(d))
          .attr('width', optionWidth(d))
          .style('width', optionWidth(d))

        // position et taille de la box en fonction de la largeur du text
        boxNodeText.filter((d: FlexNode, index: number) => idx === index)
          .attr('x', boxNodeX(d))
          .attr('y', boxNodeY(d))
          // .attr('transform', 'translate(0, '+boxNodeY(d)+')')
          .attr('width', boxNodeWidth(d) )
          .style('width', boxNodeWidth(d) )
      })
      observer.observe(n[idx] as Element)
      // console.log('observer', observer)
    })




    // design du bouton add node
/*
    const gBtn = gNode.append('g').attr('class', 'gButton').attr('transform', gBtnTransform).style('visibility', gBtnAddVisible)
    gBtn.append('circle')
      .attr('cx', Math.round(gBtnAddSize/2))
      .attr('cy', Math.round(gBtnAddSize/2))
      .attr('r', Math.round(gBtnAddSize/1.5))

    // gBtn.append('rect').attr('width', gBtnAddSize).attr('height', gBtnAddSize).attr('rx', 3).attr('ry', 3)
    gBtn.append('path').attr('d', 'M13.218,8.746H8.933v4.285H7.504V8.746H3.218V7.317h4.286V3.03h1.429v4.287h4.285V8.746z')
*/
    // le design du bouton crayon pour edition
    const nodeEditIcone = gNode.append('g')
      .attr('class', 'gEdition')
      .attr('transform', gInfosTransform)
      .style('visibility', gEditeBtnVisible)
      .style('display', gDisplayNodeZero)
    nodeEditIcone.append('rect')
      .attr('width', gBtnInfosSize)
      .attr('height', gBtnInfosSize)
      .attr('rx', 10)
      .attr('ry', 10)
      .attr('x', -1)
      .attr('y', 0)
      .style('fill', pathColor)
    nodeEditIcone.append('path')
      .attr('d', 'M3.063,12.81v2.44h2.442l7.2-7.201l-2.441-2.442L3.063,12.81z M14.593,6.161c0.253-0.254,0.253-0.665,0-0.918l-1.521-1.523 c-0.255-0.253-0.664-0.253-0.92,0l-1.19,1.191l2.44,2.442L14.593,6.161z')
      .style('fill', 'white')

    // design du bouton info
    const nodeInfosIcone = gNode.append('g')
      .attr('class', 'gInfos')
      .attr('transform', gInfosTransform)
      .style('visibility', gInfoBtnVisible)
      .style('display', gDisplayNodeZero)
      .raise()
    nodeInfosIcone.append('rect')
      .attr('width', gBtnInfosSize)
      .attr('height', gBtnInfosSize)
      .attr('rx', 10)
      .attr('ry', 10)
      .attr('x', -1)
      .attr('y', 0)
      .style('fill', pathColor)
    nodeInfosIcone.append('path')
      .attr('d', 'M10.484,3.55c0.022,0.66-0.462,1.188-1.232,1.188c-0.682,0-1.166-0.528-1.166-1.188c0-0.682,0.506-1.21,1.21-1.21	C10.022,2.34,10.484,2.868,10.484,3.55z M8.328,17.192V6.543h1.936v10.649H8.328z')
      .style('fill', 'white')
    
    // design du bouton escalade (vert)
    const nodeEscaladeIcone = gNode.append('g')
      .attr('class', 'gEscalade')
      .attr('transform', gJumpToTransform)
      .style('visibility', gEscaladeBtnVisible)
      // .style('display', gDisplayNodeZero)
      .raise()
    nodeEscaladeIcone.append('circle')
      .attr('cx', Math.round(gBtnAddSize/1.6))
      .attr('cy', Math.round(gBtnAddSize/1.6))
      .attr('r', Math.round(gBtnAddSize/1.3))
      .style('fill', '#b2df8a')
    nodeEscaladeIcone.append('path')
      .attr('d', gEscaladeBtnIcone)
      .style('fill', 'white')
    

    // affiche l'icone link si jumpTo (orange)
    const jumpTO = gNode.append('g')
      .attr('class', 'gJumpTo')
      .attr('transform', gJumpToTransform)
      .style('visibility', gJumpToBtnVisible)
    jumpTO.append('circle')
      .attr('cx', Math.round(gBtnAddSize/1.6))
      .attr('cy', Math.round(gBtnAddSize/1.6))
      .attr('r', Math.round(gBtnAddSize/1.3))
    // jumpTO.append('rect').attr('width', gBtnInfosSize).attr('height', gBtnInfosSize).attr('rx', 2).attr('ry', 2).attr('x', -1).attr('y', 0)
    jumpTO.append('path')
      .attr('class', 'gJumpToIcone')
      .attr('d', gJumpToIcone)


    // affiche le nom du lien jumpto au survole du node
    const foreignJumpTO = gNode.append('foreignObject')
      .attr('transform', gJumpToTitleTransform)
      .style('display', gDisplayNodeJumpTo)
      .style('opacity', 0)
      .attr('class', 'objectTextNodeJumpTo')
      .attr('left', (d: FlexNode) => d.data.left ? 'true' : 'false')

    // console.log('foreignDiv')
    const foreignJumpTODiv = foreignJumpTO.append('xhtml:div')
      .attr('class', 'textJumpTo')
      .style('background-color', gEscaladebackgroundColor)
      .text(gDisplayTitleJumpTo) // si pas de title on prend le label
    
    // console.log('foreignDiv', foreignDiv)
    foreignJumpTODiv.on('blur', updateNodeName).on('keydown', divKeyDown).on('mousedown', fdivMouseDown)
    foreignJumpTODiv.each((d, i, n) => {
      const observer = new ResizeObserver((l) => {
        const t = l[0].target
        // console.log('t', t)
        const b1 = getComputedStyle(t).borderTopWidth
        const b2 = getComputedStyle(t.parentNode as Element).borderTopWidth
        const spacing = (parseInt(b1, 10) + parseInt(b2, 10)) || 0
        let calcWidth = (l[0].contentRect.width + spacing * 2) + spaceNodePoint
        if(calcWidth <= 90 && !d.depth) {
          calcWidth = 90 + spaceNodePoint
        }
        // let textWidth = calcWidth >= this.textWidth ? this.textWidth : calcWidth
        // // agrandissement uniquement si c'est le text qui est edité actuellement
        // if (t.hasAttribute('contenteditable')) {
        //   if(t.getAttribute('contenteditable') === 'true') {
        //     textWidth = calcWidth
        //   }
        // }

        // console.log('textWidth', textWidth)
        foreignJumpTO.filter((d: FlexNode, index: number) => i === index)
          .attr('height', l[0].contentRect.height + spacing +10)
          // largeur fixe car je ne connais pas encore le text 
          .attr('width', this.widthJuptoText)
          // .attr('x', cascadeNodeX(d))

      })
      observer.observe(n[i] as Element)
      // console.log('observer', observer)
    })

    

    // design du bouton qui indique des nodes cachés (...)
    const ell = gNode.append('g')
      .attr('class', 'gEllipsis')
      .attr('transform', gEllTransform)
      .style('visibility', gEllVisible)
      .classed('show', (d: FlexNode) => (d.data._children?.length || 0) > 0)
      .on('click', (d: FlexNode) => expand(d.data))
    ell.append('circle').attr('cx', 4).attr('cy', 0).attr('r', 3).attr('fill', pathColor)
    ell.append('circle').attr('cx', 14).attr('cy', 0).attr('r', 2.5).attr('fill', pathColor)
    ell.append('circle').attr('cx', 24).attr('cy', 0).attr('r', 2).attr('fill', pathColor)

    const enterData = enter.data()
    if (enterData.length) {
      if (enterData[0].data.id !== '0') {
        gNode.append('path')
        .attr('id', pathId)
        .attr('class', pathClassNode)
        .lower()
        .attr('stroke', pathColor)
        .attr('d', path) 
        // .attr('style', pathStroke)
      }

      //ajout le path jump to non visible
      gNode.append('path')
        .attr('id', pathIdJumpTo)
        .attr('class', pathClassJumpto)
        .lower()
        .attr('stroke', pathJumpToColor)
        // .attr('d', pathJumpTo)
        .attr('style', 'stroke-dasharray: 4 8;')
        .style('visibility', 'hidden')
    }
    
    // design du bouton expand node
    const gBtnExpand = gNode.append('g')
      .attr('class', 'gBtnExpand')
      .attr('transform', gExpandTransform)
      .style('visibility', gBtnExpandVisible)
      .style('display', gDisplayNodeZero)
      .style('opacity', 0)
      .on('click', (d: FlexNode) => expand(d.data))
    gBtnExpand.append('circle')
      .attr('stroke', pathColor).attr('fill', pathColor)
      .attr('cx', Math.round(gBtnAddSize/2))
      .attr('cy', Math.round(gBtnAddSize/2))
      .attr('r', Math.round(gBtnAddSize/1.5))
    gBtnExpand.append('path')
      .attr('fill', pathColor)
      .attr('transform', rotateIcone)
      .attr('d', 'M13.559,10.016l-1.942,1.941L9.178,9.516l-1.204,1.203l2.44,2.44l-1.94,1.941h5.084V10.016z M13.559,6.626V1.542H8.474 l1.94,1.94L6.432,7.474H0v1.694h7.127l4.49-4.483L13.559,6.626z')

    // design du bouton collapse node
    const gBtnCollapse = gNode.append('g')
      .attr('class', 'gBtnCollapse')
      .attr('transform', gCollapseTransform)
      .style('visibility', gBtnCollapseVisible)
      .style('display', gDisplayNodeZero)
      .style('opacity', 0)
      .on('click', (d: FlexNode) => collapse(d.data))
    gBtnCollapse.append('circle')
      .attr('stroke', pathColor).attr('fill', pathColor)
      .attr('cx', Math.round(gBtnAddSize/2))
      .attr('cy', Math.round(gBtnAddSize/2))
      .attr('r', Math.round(gBtnAddSize/1.5))
    gBtnCollapse.append('path')
      .attr('fill', pathColor)
      .attr('transform', rotateIcone)
      .attr('d', 'M14.857,3.927l-1.239-1.239l-2.996,2.997l1.239,1.239L14.857,3.927z M3.955,12.275V9.199h4.912l4.751,4.754l1.239-1.239 L9.587,7.442H3.955V4.367L0,8.32L3.955,12.275z')

    gNode.each(nest) 
    foreignLabel.raise()
    // gBtn.raise()
    gBtnExpand.raise()
    gBtnCollapse.raise()
    
    return gNode
  }

  //--- update les elements svg ---//
  updateNode(update: d3.Selection<Element, FlexNode, Element, FlexNode>) {
    // console.log('updateNode')
    const {
      editeMap,
      gOpacityNode,
      gDisplayNode,
      pathIdJumpTo,
      pathJumpToColor,
      pathJumpToMove,
      // pathIdBoxNode,
      gEllTransform,
      gDisplayNodeTitle,
      gClass,
      gTransform,
      gPointTransform,
      easePolyInOut,
      foreignY,
      // gBtnTransform,
      gInfosTransform,
      pathId,
      pathClassNode,
      pathClassJumpto,
      pathColor,
      path,
      nest,
      foreignX,
      gExpandTransform,
      gBtnExpandVisible,
      expand,
      gBtnAddSize,
      gBtnCollapseVisible,
      gCollapseTransform,
      gJumpToTransform,
      gEscaladeBtnVisible,
      gEscaladeBtnIcone,
      gJumpToTitleTransform,
      gDisplayTitleJumpTo,
      gJumpToBtnVisible,
      gJumpToIcone,
      gPathId,
      boxNodeWidth,
      boxNodeHeight,
      // boxNodeX,
      // boxNodeY,
      optionWidth,
      // foreignXTitle,
      // gDisplayNodeJumpTo,
      // updateNodeName,
      // divKeyDown,
      // fdivMouseDown,
      // updateNodeName,
      // divKeyDown,
      // fdivMouseDown,
      collapse
    } = this
    update.interrupt().selectAll('*').interrupt()
    update.attr('id', gPathId)// place le bonne id si les nodes change de position
      .attr('class', gClass)
      .transition(easePolyInOut as any)
      .attr('transform', gTransform)
      .style('display', gDisplayNode)
      .style('opacity', gOpacityNode)

    update.each((d, k, m) => {
      const node = d3.select(m[k]) as d3.Selection<Element, FlexNode, null, undefined>
      // console.log('update node ', node)
      // const { xSpacing } = this
      // console.log('d.data.size[1]', d.data.size[1])
      // let textNodeWidth = (d.data.size[1] - xSpacing) <= this.textWidth ? d.data.size[1] - xSpacing : this.textWidth
      // console.log('textNodeWidth', textNodeWidth)
      // if(textNodeWidth <= 90 && !d.depth) {
      //   textNodeWidth = 90
      // } else {
      //   textNodeWidth = textNodeWidth - this.spaceNodePoint
      // }


      // la boxNode
      const boxNode = node.selectAll('.boxNode').filter((d, i, n) => (n[i] as Element).parentNode === m[k])
        .data([d]) // must rebind the children using selection.data to give them the new data.
        .attr('x', foreignX)
        .attr('y', foreignY)
        // .attr('id', pathIdBoxNode(d))
        .attr('left', (d: FlexNode) => d.data.left ? 'true' : 'false')
        .attr('width', optionWidth(d))
        .style('width', optionWidth(d))

      // la box
      boxNode.selectAll('.boxNodeRect')
        // .attr('x', boxNodeX(d))
        // .attr('y', boxNodeY(d))
        .attr('height', boxNodeHeight(d))
        .attr('width', boxNodeWidth(d) )
        .style('width', boxNodeWidth(d) )

      boxNode.selectAll('.objectTextNode')
        .attr('width', optionWidth(d))
        .style('width', optionWidth(d))
        // .attr('x', '10')

      
      // le conteneur title
      boxNode.selectAll('foreignObject')
      // .attr('x', foreignXTitle(d))
      // le title
      boxNode.selectAll('foreignObject div')
      .text(d.data.title ? '#' + d.data.title : String('#' + d.data.title)) // si pas de label on prend le title
      .style('display', gDisplayNodeTitle(d))

      const option = node.selectAll('.objectTextNode').filter((d, i, n) => (n[i] as Element).parentNode === m[k])
        .attr('width', optionWidth(d))
        .style('width', optionWidth(d))
      
      option.selectAll('.labelNode')
        .attr('width', optionWidth(d))
        .style('width', optionWidth(d))

      // le label
      const foreign = node.selectAll('foreignObject#' + d.data.dialog_node).filter((d, i, n) => (n[i] as Element).parentNode === m[k])
        .data([d]) // must rebind the children using selection.data to give them the new data.
        // .attr('x', foreignX)
        .attr('y', foreignY)
        .attr('left', (d: FlexNode) => d.data.left ? 'true' : 'false')
        // il faut trouver la bonne taille si plus petit que le max
        // .attr('width', textNodeWidth + 4)
      // console.log('update', d.data)
      // foreign.select('div').text(d.data.conditionsLabel ? d.data.conditionsLabel : String(d.data.title)) // si pas de label on prend le title
      foreign.select('div').text(!d.data.generation ? String(d.data.title) : d.data.conditionsLabel ? d.data.conditionsLabel : String(d.data.title)) // si pas de label on prend le title

      // redessine tous les path des node
      node.selectAll('path.pathNode').filter((d, i, n) => (n[i] as Element).parentNode === m[k])
        .attr('id', pathId(d))
        .attr('class', pathClassNode(d))
        .attr('stroke', pathColor(d))
        .transition(easePolyInOut as any)
        .attr('d', path(d))

      // redessine tous les path des jumpto
      node.selectAll('path.pathJumpto').filter((d, i, n) => (n[i] as Element).parentNode === m[k])
        .attr('id', pathIdJumpTo(d))
        .attr('class', pathClassJumpto(d))
        .attr('stroke', pathJumpToColor)
        .transition(easePolyInOut as any)
        .attr('d', pathJumpToMove(d))
        .style('visibility', 'hidden')


        // si ajoute un 'jump to' et trouve un noPathJump
        if (d.data.next_step && d.data.next_step.behavior == 'jump_to') {
          // console.log('ajoute un jumpTo à la place d\'un noPathJump_ ', d.data.id)
          // si on trouve un 'noPathJump_' on le remplace par un 'jumpTO_'
          node.select('path#noPathJump_' + d.data.id).filter((d, i, n) => (n[i] as Element).parentNode === m[k])
          .attr('id', pathIdJumpTo(d))
          .attr('class', pathClassJumpto(d))
          .attr('stroke', pathJumpToColor)
          .transition(easePolyInOut as any)
          .attr('d', pathJumpToMove(d))
          .style('visibility', 'hidden')
          // si il y a deja un 'jumpTO_' on redessine sont path
          // node.select('path#jumpTo_' + d.data.id).filter((d, i, n) => (n[i] as Element).parentNode === m[k])
          // .attr('stroke', pathJumpToColor)
          // .transition(easePolyInOut as any)
          // .attr('d', pathJumpToMove(d))
          // .style('visibility', 'hidden')
        } else if (!d.data.next_step || (d.data.next_step && d.data.next_step.behavior !== 'jump_to')) {
          // console.log('retire un jumpTo et remplace par un noPathJump_ ', d.data.id)
          node.select('path#jumpTo_' + d.data.id).filter((d, i, n) => (n[i] as Element).parentNode === m[k])
          .attr('id', pathIdJumpTo(d))
          .attr('class', pathClassJumpto(d))
          .attr('stroke', pathJumpToColor)
          .transition(easePolyInOut as any)
          .style('visibility', 'hidden')
        }



      // console.log('d.data.next_step', d.data.next_step)
      // si il y a un 'jump to'
      if ((d.data.next_step && d.data.next_step.behavior == 'jump_to') || d.data.output.targetfirst) {
        // console.log('add path jumpTo', node.select('path').filter((d, i, n) => (n[i] as Element).parentNode === m[k]))
        const foreignJumpTo = node.selectAll('foreignObject.objectTextNodeJumpTo').filter((d, i, n) => (n[i] as Element).parentNode === m[k])
        .data([d]) // must rebind the children using selection.data to give them the new data.
        .attr('transform', gJumpToTitleTransform)
        .attr('left', (d: FlexNode) => d.data.left ? 'true' : 'false')
        .style('display', 'block')
        foreignJumpTo.select('div')
        .text(gDisplayTitleJumpTo) // si pas de title on prend le label
        // modification du bouton jumpTo (orange)
        node.select('g.gJumpTo').filter((d, i, n) => (n[i] as Element).parentNode === m[k]).data([d])
          .style('visibility', gJumpToBtnVisible)
          .attr('transform', gJumpToTransform)
        
          // .raise()
      } else {

        const foreignJumpTo = node.selectAll('foreignObject.objectTextNodeJumpTo').filter((d, i, n) => (n[i] as Element).parentNode === m[k])
        .data([d]) // must rebind the children using selection.data to give them the new data.
        .attr('transform', gJumpToTitleTransform)
        .attr('left', (d: FlexNode) => d.data.left ? 'true' : 'false')
        .style('display', 'none')
        foreignJumpTo.select('div')
        .text('') // si pas de title on prend le label

        // modification du bouton jumpTo (orange)
        node.select('g.gJumpTo').filter((d, i, n) => (n[i] as Element).parentNode === m[k])
          .data([d])
          .style('visibility', gJumpToBtnVisible)
          .attr('transform', gJumpToTransform)
        // node.select('g.gJumpTo').select('path').filter((d, i, n) => (n[i] as Element).parentNode === m[k]).data([d])
        //   .attr('id', 'nodeModifPath')
      }

        // modification du bouton jumpTo (orange)
        const Jumpto = node.select('g.gJumpTo')
          .filter((d, i, n) => (n[i] as Element).parentNode === m[k])
          .data([d])
        Jumpto.select('.gJumpToIcone')
          .attr('d', gJumpToIcone)

      node.each(nest)
      foreign.raise()

      const nodeEscaladeIcone = node.selectAll('g.gEscalade').filter((d, i, n) => (n[i] as Element).parentNode === m[k]).data([d])
        .attr('transform', gJumpToTransform)
        .style('visibility', gEscaladeBtnVisible)
        nodeEscaladeIcone.select('circle')
        .attr('cx', Math.round(gBtnAddSize/1.6))
        .attr('cy', Math.round(gBtnAddSize/1.6))
        .attr('r', Math.round(gBtnAddSize/1.3))
        .style('fill', '#b2df8a')
      nodeEscaladeIcone.select('path')
        .attr('d', gEscaladeBtnIcone)
        .style('fill', 'white')

      const ellFlag = (d.data._children?.length || 0) > 0

      // le bouton infos node
      const gBtnInfo = node.selectAll('g.gInfos').filter((d, i, n) => (n[i] as Element).parentNode === m[k]).data([d])
        .attr('transform', gInfosTransform)
      // le bouton edition node
      const gBtnEdition = node.selectAll('g.gEdition').filter((d, i, n) => (n[i] as Element).parentNode === m[k]).data([d])
        .attr('transform', gInfosTransform)

      // affiche un point pour indiquer le point de depart du path
      node.selectAll('g.gPoint').filter((d, i, n) => (n[i] as Element).parentNode === m[k]).data([d])
        .attr('transform', gPointTransform)
        // .raise()

      

      const ell = node.selectAll('g.gEllipsis').filter((d, i, n) => (n[i] as Element).parentNode === m[k]).data([d])
        .attr('transform', gEllTransform)
        .classed('show', ellFlag)
        .style('visibility', ellFlag ? 'visible' : 'hidden')
      ell.select('rect.btn').attr('stroke', pathColor).attr('fill', pathColor)

      // design du bouton expand node


      const gBtnExpand = node.selectAll('g.gBtnExpand').filter((d, i, n) => (n[i] as Element).parentNode === m[k]).data([d])
        .attr('transform', gExpandTransform)
        .style('visibility', gBtnExpandVisible)
        .style('opacity', 0)
        .on('click', (d: FlexNode) => expand(d.data))

      // design du bouton collapse node
      const gBtnCollapse = node.selectAll('g.gBtnCollapse').filter((d, i, n) => (n[i] as Element).parentNode === m[k]).data([d])
        .attr('transform', gCollapseTransform)
        .style('visibility', gBtnCollapseVisible)
        .style('opacity', 0)
        .on('click', (d: FlexNode) => collapse(d.data))

    


      // le bouton add node
      /*
      node.selectAll('g.gButton').filter((d, i, n) => (n[i] as Element).parentNode === m[k]).data([d])
        .attr('transform', gBtnTransform)
        .style('visibility', !ellFlag && !d.data.next_step ? 'visible' : 'hidden')
        .raise()
      */
      // le bouton add node
      // node.selectAll('g').filter((d, i, n) => (n[i] as Element).parentNode === m[k]).data([d])
      //   .attr('transform', gTransform)
      //   .style('visibility', gTechniqueVisible)
      //   .raise()

      gBtnExpand.raise()
      gBtnCollapse.raise()
      if (editeMap) {
        gBtnEdition.raise()
        nodeEscaladeIcone.raise()
      } else {
        gBtnInfo.raise()
      }
    })
    return update
  }

  //--- update les path jumpTo ---//
  updatePathJump(updateJumpTO: d3.Selection<Element, FlexNode, Element, FlexNode>) {
    // console.log('update')
    const { pathIdJumpTo, pathJumpToColor, pathJumpToMove, gClass, gTransform, easePolyInOut, pathClassNode, nest } = this
    updateJumpTO.interrupt().selectAll('*').interrupt()
    updateJumpTO.attr('class', gClass).transition(easePolyInOut as any).attr('transform', gTransform)

    updateJumpTO.each((d, k, m) => {
      const node = d3.select(m[k]) as d3.Selection<Element, FlexNode, null, undefined>
        // si il y a un 'jump to'
        if (d.data.next_step && d.data.next_step.behavior == 'jump_to') {
          // console.log('il y a un jump to ici')
          node.select('path').filter((d, i, n) => (n[i] as Element).parentNode === m[k])
          .attr('id', pathIdJumpTo(d))
          .attr('class', pathClassNode(d))
          .attr('stroke', pathJumpToColor)
          .transition(easePolyInOut as any)
          .attr('d', pathJumpToMove(d))
        }
      node.each(nest)
    })
    return updateJumpTO
  }

  // ouvre la snackBars
  openSnackBars (open: Boolean, text: String, color: String ) {
    this.snackBarVisible = open
    this.snackBarText = text
    this.snackBarColor = color
  }

  exitNode(exit: d3.Selection<Element, FlexNode, Element, FlexNode>) {
    exit.filter((d, i, n) => n[i].classList[1] === 'node').remove()
  }

  // dessine tout le mindmap
  draw() { // svg
    const { dKey, mindmapG, appendNode, updateNode, exitNode } = this
    const d = [this.root]
    // console.log('draw mindmapG', mindmapG)
    ;(mindmapG.selectAll(`g${d[0] ? `.depth_${d[0].depth}.node` : ''}`) as d3.Selection<Element, FlexNode, Element, FlexNode>)
      .data(d, dKey)
      .join(appendNode, updateNode, exitNode)
  }

  // redessine le path du jump to
  drawPathJump() { // svg
    const {mindmapG, updatePathJump} = this
    const d = [this.root]
    // console.log('drawPathJump', d)
    setTimeout(
      function() { updatePathJump(mindmapG.selectAll(`g${d[0] ? `.depth_${d[0].depth}.node` : ''}`) as d3.Selection<Element, FlexNode, Element, FlexNode>) },
      500
    )
  }

  // creation des branches du mindmap
  tree() {
    const { ySpacing} = this
    const layout = flextree({ spacing: ySpacing })
    // console.log('tree :: mmdata.data', mmdata.data)
    const yGap = mmdata.data.title ? mmdata.data.size[1] / 2 : 1

    // left
    const treeLeft = layout.hierarchy(mmdata.data, (d: Mdata) => d.id.split('-').length === 1 ? (d.children || d.options)?.filter(d => d.left) : (d.children || d.options))
    layout(treeLeft)
    // console.log('treeLeft', yGap)
    treeLeft.each((a: FlexNode) => { if (a.data.id !== '0') { a.y = -a.y + yGap } })

    // right
    const treeRight = layout.hierarchy(mmdata.data, (d: Mdata) => d.id.split('-').length === 1 ? (d.children || d.options)?.filter(d => !d.left) : (d.children || d.options))
    layout(treeRight)
    // console.log('treeRight', treeRight)
    treeRight.each((a: FlexNode) => { if (a.data.id !== '0') { a.y = a.y - yGap } })

    // all
    // console.log('treeRight.children', treeRight.children)
    // console.log('treeLeft.children', treeRight.children.concat(treeLeft.children))
    treeRight.children = treeLeft.children
      ? (treeRight.children ? treeRight.children.concat(treeLeft.children) : treeLeft.children)
      : treeRight.children
    treeRight.each((a: FlexNode) => {
      if (a.data.id !== '0') {
        a.x += a.size[0] / 2
      }
      a.dx = a.x - (a.parent ? a.parent.x : 0)
      a.dy = a.y - (a.parent ? a.parent.y : 0)
      a.px = 0
      a.py = 0
    })
    this.root = treeRight
    // console.log('this.root', this.root)
    this.draw() // redessine la mindmap
  }
  
  getDTop() {
    // console.log('this.root', this.root)
    let t = this.root
    while (t.children) { t = t.children[0] }
    this.dTop = t
  }
  getSize(text: string, root = false) {
    const { dummy, xSpacing, minTextWidth, minTextHeight } = this
    let textWidth = 0
    let textHeight = 0
    dummy.selectAll('.dummyText').data([text]).enter().append('div').text((d) => d)
      .each((d, i, n) => {
        textWidth = n[i].offsetWidth >= this.textWidth ? this.textWidth : n[i].offsetWidth // il y a une taille max
        textHeight = n[i].offsetHeight
        n[i].remove() // remove them just after displaying them
      })
    textWidth = Math.max(minTextWidth, textWidth)
    textHeight = Math.max(minTextHeight, textHeight)
    // let txtNewWidth = textWidth >= this.textWidth ? this.textWidth : textWidth
    // console.log('getSize txtNewWidth', textWidth)
    // console.log('getSize txtNewWidth 2', textWidth + (root ? xSpacing * 2 : xSpacing))
    return [textHeight, textWidth + (root ? xSpacing * 2 : xSpacing)]
  }
  clearSelection() {
    if (window.getSelection) {
      const sel = window.getSelection()
      sel?.removeAllRanges()
    }
  }

  addWatch() {
    this.$watch('value', (newVal) => {
      if (this.toUpdate) {
        mmdata = new ImData(newVal[0], this.getSize)
        this.updateMmdata()
      } else {
        this.toUpdate = true
      }
    }, { immediate: true, deep: true })
  }

  // création d'un tableau avec la liste de tous les nodes utilisés
  getListeAllNodes () {
    this.arrayAllNodes = []
    this.arboNodes = []
    // création d'une arborescence des nodes pour etre utilisée dans les jumpTo
    let listeComportement:any = this.rechercheAllNodes(_.cloneDeep(mmdata.data), true)
    // console.log('listeComportement', listeComportement)
    _.forEach(listeComportement.children, (child:any) => {
      // console.log('child', child)
      delete child.children
      this.arboNodes.push(child)
      this.arrayAllNodes.push(child)
    })
    // this.arboComportement.push(this.rechercheAllNodes(_.cloneDeep(mmdata.data), true))
    this.arboNodes.push(this.rechercheAllNodes(_.cloneDeep(mmdata.data), false))
    // console.log('--- arboNodes ---', this.arboNodes)
    // console.log('arboComportement', this.arboComportement)
  }

  // recupère les infos du jumpTo du node selectonné
  getInfosJumpTo(data:any) {
    this.treeOpen = []
    // console.log('infosJumpTo', data)
    this.findNodeInfos(_.cloneDeep(mmdata.data), data).then(resolve => {
      this.infosJumpTo = resolve
      // console.log('infosJumpTo', this.infosJumpTo.title)
    })
  }

  // retourne un tableau complet de tous les node children
  findNodeInfos(data:any, dialog_node:string) {
    const thisConst = this
    let childFind:any = ''
    findInfos(data, dialog_node)
    // console.log('findNodeInfos', data)
    function findInfos(data:any, dialog_node:string) {
      if (data.dialog_node === dialog_node) {
        childFind = data
        thisConst.parentsNodeSelected(data.parent)
      }
      const { children, _children } = data
      if (children) {
        children.forEach((child:any) => {
          // console.log(child)
          if (child.dialog_node === dialog_node) {
            childFind = child
            thisConst.parentsNodeSelected(child.parent)
          }
          findInfos(child, dialog_node)
        })
      }
      if (_children) {
        _children.forEach((child:any) => {
          // console.log(child)
          if (child.dialog_node === dialog_node) {
            childFind = child
            thisConst.parentsNodeSelected(child.parent)
          }
          findInfos(child, dialog_node)
        })
      }
      // console.log('findNodeInfo :: ', childFind)
    }
    // console.log('childFind', childFind)
    return new Promise((resolve) => {
      resolve(childFind)
    })
  }
  // pour remplir le tableau des dislog_node pour déployer l'arborescence jusqu'au jumpTo
  parentsNodeSelected (parent:any) {
    // console.log('parentsNodeSelected', parent)
    const thisConst = this
    this.treeOpen.push(parent)
    const data = _.cloneDeep(mmdata.data)
    openTree(data, parent)
    function openTree(data:any, parent:string) {
      const { children, _children } = data
      if (children) {
        children.forEach((child:any) => {
          // console.log(child)
          if (child.dialog_node === parent) {
            thisConst.treeOpen.push(child.parent)
          }
          openTree(child, child.parent)
        })
      }
      if (_children) {
        _children.forEach((child:any) => {
          // console.log(child)
          if (child.dialog_node === parent) {
            thisConst.treeOpen.push(child.parent)
          }
          openTree(child, child.parent)
        })
      }
    }
  }

  // recheche tous les nodes pour en faire une arborescence utilisable pour les jumpTo
  rechercheAllNodes(data:any, comportement:Boolean) {
    // deploie toutes les branches
    // uniquement pour le node 0
    if (!data.generation && !comportement) {
      data.name = data.title ? data.title : data.conditionsLabel
      data.value = data.dialog_node
      data.icone = 'location_on'
      delete data.output
      delete data.dialog_node
      delete data.left
      this.arrayAllNodes.push(data)
    } else if (!data.generation && comportement) {
      data.name = 'Comportements'
      delete data.value
      delete data.title
      delete data.output
      delete data.dialog_node
      // delete data.left
      // this.arrayAllNodes.push(data)
    }
    delete data.color
    delete data.cascade
    delete data.private
    delete data.conditions
    delete data.conditionsLabel
    delete data.created
    delete data.gKey
    delete data.next_step
    delete data.previous_sibling
    delete data.updated
    delete data.type
    delete data.tfstart
    delete data.size
    delete data.id
    delete data.parent
    delete data.generation

    const { children, _children } = data
    // console.log('expandeAllbranches children', children)
    // console.log('expandeAllbranches _children', _children)
    if (children) {
      // on retire les node technique (ceux qui ce trouvent à gauche)
      let newChildren = comportement ? children.filter((child:any) => child.left) : children.filter((child:any) => !child.left)
      data.children = newChildren
      children.forEach((child:any) => {
        child.name = child.conditionsLabel ? child.conditionsLabel : child.title
        child.value = child.dialog_node
        if (comportement) {
          child.icone = 'schema'
        } else {
          child.icone = 'location_on'
          // ajoute ce node dans la liste si il est à droite (ce n'est pas un comportement)
          if(!_.find(this.arrayAllNodes, function(o:any) { return o.value === child.dialog_node})) {
            this.arrayAllNodes.push(child)
          }
        }
        // console.log('comprtement', comportement)
        // console.log('child', child)
        delete child.output
        delete child.dialog_node
        delete child.left
        this.rechercheAllNodes(child, comportement)
      })
    }
    if (_children) {
      // on retire les node technique (ceux qui ce trouvent à gauche)
      let newChildren = comportement ? _children.filter((child:any) => child.left) : _children.filter((child:any) => !child.left)
      data._children = newChildren
      _children.forEach((_child:any) => {
        _child.name = _child.conditionsLabel ? _child.conditionsLabel : _child.title
        _child.value = _child.dialog_node
        if (comportement) {
          _child.icone = 'schema'
        } else {
          _child.icone = 'location_on'
          // ajoute ce node dans la liste si il est à droite (ce n'est pas un comportement)
          if(!_.find(this.arrayAllNodes, function(o:any) { return o.value === _child.dialog_node})) {
            this.arrayAllNodes.push(_child)
          }
        }
        // console.log('comprtement', comportement)
        // console.log('_child', _child)
        delete _child.output
        delete _child.dialog_node
        delete _child.left
        // console.log('_child', _child)
        this.rechercheAllNodes(_child, comportement)
        data.children.push(_child)
        // _children.splice(index, 1)
      })
    }
    // console.log('expandeAllbranches suite', data)
    // console.log('arrayAllNodes', this.arrayAllNodes)
    delete data._children
    return data
  }

  dateFromNow(date:any) {
    // console.log('date', date)
    // var dateString = moment.unix(date)
    // console.log('date', dateString)
    // return dateString
    return moment.utc(date).fromNow()
  }

  // Pour supprimer les node delai qui servent à rien
  removeNodeDelay(node:any) {
    if(node.output && node.output.generic) {
      for (let a in node.output.generic) {
        if (node.output.generic[a].response_type === 'pause') {
          // console.log('touvé pause', node.dialog_node)
          node.output.generic.splice(a, 1)
        }
      }
    }
    return node
  }

  //Ouvre la popup d'avertissement de suppression
  optionDelete(nodeToDel: any) {
    // console.log('nodeToDel', nodeToDel)
    this.editorToggleHTML = false
    this.editOptionNum = -1 // ferme l'éditeur ouvert
    this.branchToDel = nodeToDel
    // this.branchToDel.value = nodeToDel.value

    this.branchToDel.label = this.branchToDel.label.replace(/<\/p>/gm, "")
    this.branchToDel.label = this.branchToDel.label.replace(/<p>/gm, "")

    // if(confirm('ATTENTION. Lorsque vous cliquerez sur "METTRE A JOUR", la branche ' + this.branchToDel.label + ' et tous ses enfants seront définitivement supprimées.')) {
      // nodeToDel.label = ''
      // this.branchesToDelete.push(this.branchToDel)
    // }

    // ajoute dans le tableau les node à supprimer
    // this.branchesToDelete.push(this.branchToDel)
    this.showPopUpValidDel = true

    // console.log('branchesToDelete')
    // console.log(JSON.stringify(this.branchesToDelete))
    // this.openSnackBars(true, 'Toutes vos modifications n\'ont pas été enregistrées', 'blue darken-3')
  }

  // confirme la suppression du node
  confirmDeleteNode (nodeID:any) {
    // console.log('confirmDeleteNode', nodeID)
    // console.log(' this.selectMenuNode',  this.selectMenuNode)
    // pour supprimer la branche en base/watson
    this.branchesToDelete.push(this.branchToDel)
    // this.del(this.branchToDel)
    // this.submitModif()
    this.showPopUpValidDel = false
    //  afface dans la branche visible
    if (this.selectMenuNode.data.children) {
      for (let i = 0; i < this.selectMenuNode.data.children.length; i++) {
        let index = this.selectMenuNode.data.children[i].conditions.indexOf(nodeID)
        if(index !== -1) {
          // console.log ('trouvé', this.selectMenuNode.data.children[i])
          // find = i
          this.selectMenuNode.data.children.splice(i, 1)
        } else {
          // console.log ('pas trouvé')
        }
      }
    }
    //  afface dans la branche invisible
    if (this.selectMenuNode.data._children) {
      for (let i = 0; i < this.selectMenuNode.data._children.length; i++) {
        let index = this.selectMenuNode.data._children[i].conditions.indexOf(nodeID)
        if(index !== -1) {
          // console.log ('trouvé', this.selectMenuNode.data._children[i])
          // find = i
          this.selectMenuNode.data._children.splice(i, 1)
        } else {
          // console.log ('pas trouvé')
        }
      }
    }
    // efface l'option
    // console.log('efface option', this.selectMenuNode.data.output)
    let allOptions:any = this.selectMenuNode.data.output
    // console.log('allOptions.generic.length', allOptions.generic.length)
    if (allOptions.generic.length) {
      // retouve le tableau des options
        allOptions.generic.forEach((elm:any) => {
          // si trouvé des options
          if (elm.options) {
            Object.keys(elm.options).forEach((index) => {
              // console.log('index :' + index + ' i:' + i + ' :: ' + elm.options[i].label)
                if(elm.options[index] && elm.options[index].value.input.text === nodeID){
                  // console.log ('option trouvé', elm.options[index])
                  // delete elm.options[index]
                  elm.options.splice(index, 1)
                }
            })
          }
        })

      // for (let a = 0; a < allOptions.generic.length; a++) {
      //   if (allOptions.generic[a].options) {
      //     if (allOptions.generic[a].options.length) {
      //       for (let b = 0; b < allOptions.generic[a].options.length; b++) {
      //         if(allOptions.generic[a].options[b].value.input.text === nodeID){
      //           console.log ('option trouvé', allOptions.generic[a].options[b].label)
      //           allOptions.generic[a].options.splice(b, 1)
      //         }
      //       }
      //     }
      //   }
      // }
    }
    // console.log('this.selectMenuNode.children', this.selectMenuNode.children)
    mmdata.changeInNode(this.selectMenuNode.data)
    this.updateMmdata()
  }

  // annule la mise à jour d'un noeud et repart d'un clone du node selectionné'
  cancelModif() {
    this.editorToggleHTML = false // fermer l'editeur de html
    this.editNewJumpTo = false
    this.editNewTransfert = false
    // console.log('--> cancelModif : this.selectMenuNode.data', this.selectMenuNode.data)
    // console.log('--> cancelModif : this.cloneFlexNode', this.cloneFlexNode)
    this.showPopUpOption = false
    this.newitem.label = '';
    this.branchesToDelete = []
    this.newJumpTo = []
    this.newTransfert = ''
    this.editNewOption = false
    this.editNewContentChatbot = false
    
     
    // remet la tree comme avant sans les modifs non enregistré
    let data:Mdata = this.cloneFlexNode.data
    // let modifMdata
    let newTitleNode:string = ''
    console.log('data', data)
    // console.log('selectNodeInfos', this.selectNodeInfos.dialog_node)
    if (this.selectNodeInfos.dialog_node === data.dialog_node) {
      if (this.$refs.form.inputs.length) {
        // on enregistre
        this.toRecord = true
        for (let i in this.$refs.form.inputs) {
          // console.log('this.$refs.form.inputs[i]')
          console.log(this.$refs.form.inputs[i])
          if(this.$refs.form.inputs[i].label.indexOf('Nom du noeud') !== -1) {
            data.title = this.$refs.form.inputs[i].internalValue
            // modifMdata = mmdata.rename(data.id, this.$refs.form.inputs[i].internalValue)
            newTitleNode = this.$refs.form.inputs[i].internalValue
          } else if (this.$refs.form.inputs[i].label === 'dialog_node') {
            data.dialog_node = this.$refs.form.inputs[i].internalValue 
          } else if(this.$refs.form.inputs[i].label === 'type') {
            data.type = this.$refs.form.inputs[i].internalValue
          } else if (this.$refs.form.inputs[i].label === 'conditions') {
            data.conditions = this.$refs.form.inputs[i].internalValue
          } else if (this.$refs.form.inputs[i].label === 'conditionsLabel') {
            data.conditionsLabel = this.$refs.form.inputs[i].internalValue
          } else if (this.$refs.form.inputs[i].label === 'Choisir une escalade') {
            if (data.next_step !== '') {
              data.next_step.dialog_node = this.$refs.form.inputs[i].internalValue
            }
          }
        }
      }
    }

    if (this.selectNodeInfos.title && this.selectNodeInfos.title !== '') {
      newTitleNode = this.selectNodeInfos.title
      if (this.selectNodeInfos.conditions.indexOf('#tfstart') !== -1) {
        // indispensable de rajouter la nomenclature :tfstart
        newTitleNode = ':tfstart ' + newTitleNode
      }
      if(this.selectNodeInfos.cascade && this.selectNodeInfos.cascade === 1) {
        newTitleNode = ':cascade ' + newTitleNode
      }
      console.log('newTitleNode', newTitleNode)
      // mise à jour de watson et la bdd
      //this.$emit('updateBddAndWatsonTitle', data.dialog_node, newTitleNode)
    }
    //for (let node in mmdata.data) {
      // console.log('node', this.cloneFlexNode.data.id)
    //}
    mmdata.restoreCloneNode(this.cloneFlexNode.data)
    this.updateMmdata()
  }

  // test les longeurs de chaines avant envois
  testModif() {
    // console.log('--> testModif : ', this.selectNodeInfos.output.generic)
    if(this.selectNodeInfos.output.generic.length > 0) {
      // console.log('++modification du output du node', this.newitem.label)
      // test la longueurs des chaines avant envois en base

      const out:any = this.selectNodeInfos.output.generic[0]
      // console.log('out', out)
      let testOK = 0
      // test le titre
      if(out.title.length > this.maxlengthTitle ) {
        // console.log('title trop long')
        testOK++
      }
      // test pour chaque option
      if(out.options.length) {
        out.options.forEach((option:any) => {
          if (option.label.length > this.maxlengthOption) {
            // console.log('label trop long')
            testOK++
          }
        })
      }
      // test la nouvelle option
      if(this.newitem.label.length > this.maxlengthOption ) {
        // console.log('new option trop long')
        testOK++
      }
      // redirection identique au node selectionné
      if (this.selectNodeInfos.dialog_node &&
          this.newJumpTo.length &&
          this.newJumpTo[0] === this.selectNodeInfos.dialog_node) {
            testOK++
      }

      // console.log('testOK', testOK)
      if(!testOK) {
        // console.log('on peut sauver')
        this.submitModif()
      } else {
        
        if (this.selectNodeInfos.dialog_node &&
            this.newJumpTo.length &&
            this.newJumpTo[0] === this.selectNodeInfos.dialog_node) {
            this.showPopUpIndos = true
        } else {
          this.showPopUpLongText = true
        }

      }
    }
  }

  // enregistre les modifications du node
  submitModif() {
    // console.log('--> submitModif : this.selectMenuNode.data', this.selectMenuNode)
    // console.log('--> submitModif : newJumpTo', this.newJumpTo)
    let newOption = ''
    // console.log('submit ouyput', this.selectNodeInfos.output.generic)
    if (this.editNewOption) {
      if (this.newitem.label === '') {
        alert('Attention, la nouvelle branche est vide, elle ne sera pas créé')
      }
      else {
        newOption = this.newitem.label
      }
    }
    // console.log('--> submitModif  newOption :', newOption)

  // console.log('--> submitModif : this.selectNodeInfos', this.selectNodeInfos)
    if (this.selectNodeInfos.title == '') {
      this.openSnackBars(true, 'La description du nœud ne peut pas etre vide', 'error')
      this.showPopUpOption = false
      this.selectNodeInfos.title = this.cloneFlexNode.data.title
      return false
    }

    // pour mettre à jour la Tree
    let data:Mdata = this.selectMenuNode.data
    let modifMdata
    let newTitleNode:string = ''
    // console.log('data', data)
    // console.log('selectNodeInfos', this.selectNodeInfos.dialog_node)
    if (this.selectNodeInfos.dialog_node === data.dialog_node) {
      if (this.$refs.form.inputs.length) {
        // on enregistre
        this.toRecord = true
        for (let i in this.$refs.form.inputs) {
          // console.log('this.$refs.form.inputs[i]', this.$refs.form.inputs[i])
          // console.log('label : ', this.$refs.form.inputs[i].label)
          // console.log('value: ', this.$refs.form.inputs[i].internalValue)
          if(this.$refs.form.inputs[i].label) {
            if(this.$refs.form.inputs[i].label.indexOf('Nom du noeud') !== -1) {
              data.title = this.$refs.form.inputs[i].internalValue
              modifMdata = mmdata.rename(data.id, this.$refs.form.inputs[i].internalValue)
              newTitleNode = this.$refs.form.inputs[i].internalValue
            } else if (this.$refs.form.inputs[i].label === 'dialog_node') {
              data.dialog_node = this.$refs.form.inputs[i].internalValue 
            } else if(this.$refs.form.inputs[i].label === 'type') {
              data.type = this.$refs.form.inputs[i].internalValue
            } else if (this.$refs.form.inputs[i].label === 'conditions') {
              data.conditions = this.$refs.form.inputs[i].internalValue
            } else if (this.$refs.form.inputs[i].label === 'conditionsLabel') {
              data.conditionsLabel = this.$refs.form.inputs[i].internalValue
            } else if (this.$refs.form.inputs[i].label === 'Choisir une escalade') {
              if (data.next_step !== '') {
                data.next_step.dialog_node = this.$refs.form.inputs[i].internalValue
              }
            }
          }
        }
      }
    }

    // console.log('Pour le changement de title this.selectNodeInfos', this.selectNodeInfos)
    // console.log('Pour le changement de title data', data)
    
    if (this.selectNodeInfos.title && this.selectNodeInfos.title !== '') {
      // console.log('### change le title du node', this.selectNodeInfos)
      newTitleNode = this.selectNodeInfos.title
      if (this.selectNodeInfos.conditions.indexOf('#tfstart') !== -1) {
        // indispensable de rajouter la nomenclature :tfstart
        newTitleNode = ':tfstart ' + newTitleNode
      }
      if(this.selectNodeInfos.cascade && this.selectNodeInfos.cascade === 1) {
        newTitleNode = ':cascade ' + newTitleNode
      }
      // mise à jour de watson et la bdd
      // this.$emit('updateBddAndWatsonTitle', data.dialog_node, newTitleNode)
      this.updateBddAndWatsonTitle( data.dialog_node, newTitleNode)
    }
    // console.log('this.newTransfert', this.newTransfert)
    let outputgeneric = ''
    if(this.selectNodeInfos.output.generic.length > 0) {
      let jumpTo = ''
      if (this.newJumpTo.length){
        jumpTo = this.newJumpTo[0]
      }
      // console.log('modification du output du node')
      outputgeneric = JSON.stringify(this.selectNodeInfos.output.generic)
      outputgeneric = outputgeneric.replace(/<p>/gm, "")
      outputgeneric = outputgeneric.replace(/<\/p>/gm, "")
      newOption = newOption.replace(/<\/p>/gm, "")
      newOption = newOption.replace(/<p>/gm, "")
      newOption = newOption.replace(/<\/br>/gm, "")
      newOption = newOption.replace(/<br>/gm, "")
      // console.log('newOption', newOption)
      // console.log('outputgeneric', outputgeneric)
      // mise à jour de watson et la bdd
      this.updateBddAndWatsonOutput(data.dialog_node, outputgeneric, newOption, JSON.stringify(this.branchesToDelete), jumpTo, this.newTransfert)
      this.branchesToDelete = []
      this.newJumpTo = []
      // this.newTransfert = ''
    }
    // Modifier directement l'ARBRE -> non, le faire au niveau au dessus
    // mmdata.data.title = 'toto';
    this.showPopUpOption = false   
    this.makeNodeAdd(false)
    // ferme la popup si ouverte
    this.showPopUpValidDel = false
    this.showPopUpValidDel2 = false
	// on vide le champs nouvelle option
    this.newitem.label = '';
    this.editNewContentChatbot = false
    this.editNewOption = false
    this.editNewJumpTo = false
    this.editNewTransfert = false
    // console.log('submitModif : modifMdata', modifMdata)
    return modifMdata
  }

  updateBddAndWatsonOutput(id:string, output:string, newOption:string, nodesToDelete: string, jumpTo: string, transfert: string) {
    this.saveData = true
    console.log('updateBddAndWatsonOutput id', id)
    output = output.replace(/&lt;/gm, '%3c')
    output = output.replace(/&gt;/gm, '%3e')
    output = output.replace(/&amp;/gm, '%26')
    output = output.replace(/&nbsp;/gm, ' ')
    output = output.replace(/nbsp;/gm, ' ')
    output = output.replace(/&quot;/g, '\\"')
    // console.log('updateBddAndWatson output', output)
    let xhr = new XMLHttpRequest()
    if (xhr) {
      let vwParams = 'botWorkspace=' + this.botWorkspace + '&dialog_node=' + id + '&output=' + output + '&newOption=' + newOption + '&nodesToDelete=' + nodesToDelete + '&jumpTo=' + jumpTo  + '&transfert=' + transfert
      // listen for `progress` event
      xhr.onprogress = event => {
        // event.loaded returns how many bytes are downloaded
        // event.total returns the total number of bytes
        // event.total is only available if server sends `Content-Length` header
        console.log(`Downloaded ${event.loaded} of ${event.total} bytes`)
      }
      xhr.onload = () => {
        if(xhr.responseText && xhr.responseText !== '')
        {
          this.$emit('changeBot')
          let optionReturn = JSON.parse(xhr.responseText)
          let dataNode:any
          let dataNextStep:any
          if (optionReturn.length) {
            optionReturn.forEach((item:any) => {
              // si un nouveau node
              if (item.dialog_node) {
                // console.log('item.dialog_node', item.dialog_node)
                dataNode = item
              }

              // changement dans le output du node selectionné
              // uniquement si marqueur "outputChange" present dans le retour php
              if (item.output) {
                if (item.output.outputChange === '1') {
                  // console.log('changement dans  le item.output', item.output)
                  // dataNode = item
                  mmdata.changeOutput(this.selectMenuNode.data, item.output)
                }
              }

              // si il y a un next_step
              if (item.next_step) {
                // console.log('item.next_step', item.next_step)
                dataNextStep = item
              } else if (item.next_step === '') {
                // console.log('item.next_step VIDE !!!')
                dataNextStep = 'efface'
              }
            })
          }
          // if (optionReturn.length && optionReturn[0].dialog_node) {
          //   dataNode = optionReturn[0]
          // } else if (optionReturn.length && optionReturn[1].dialog_node) {
          //   dataNode = optionReturn[1]
          // }
          // si on ajoute ou change un jumpto
          if (dataNextStep) {
            // console.log('modiffication du next step', dataNextStep)
            let data:Mdata = this.selectMenuNode.data
            let dataNewNode = dataNextStep.next_step
            this.modifJumpTo(data, dataNewNode)
          }

          if (dataNode) {
            let data:Mdata = this.selectMenuNode.data
            const newGeneration = this.selectMenuNode.data.generation + 1
            // on ajoute immédiatement un nouveau noeud, en attedant que la map se recharge
            // console.log('ajoute une option au node', data)
            let dataNewNode = {
              children: [],
              name: dataNode.title,
              label: dataNode.title,
              title: dataNode.title,
              next_step: '',
              left: false,
              conditionsLabel: dataNode.title,
              conditions: dataNode.conditions,
              dialog_node: dataNode.dialog_node,
              parent: dataNode.parent,
              previous_sibling: dataNode.previous_sibling,
              generation: newGeneration,
              cascade: 0,
              private: 0,
              tfstart: 0,
              type: dataNode.type,
              output: dataNode.output,
              _children: []
            }
            this.add(data, dataNewNode)
          }

          // ajout de la nouvelle l'option dans "outpu.generic.options"
          this.editNewTransfert = false
          this.saveData = false
          this.newTransfert = ''
          this.openSnackBars(true, 'Modifications du chatbot ont bien été enregistrées', 'success')
          this.updateMmdata()
          this.updateMindmap()
          mmdata.resize()
          this.fitContent()
        }
      }
      // this.addListeners(xhr)
      xhr.open('POST', 'https://www.watcheezy.net/public/ibm/set_node.php')
      xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded'); // pour le POST
      xhr.send(vwParams);
    }
  }

  // enregitrement du chanengemant de titre
  updateBddAndWatsonTitle(id:string, title:string) {
    this.saveData = true
    // console.log('updateBddAndWatsonTitle id', id)
    // console.log('updateBddAndWatson title', title)
    let xhr = new XMLHttpRequest()
    if (xhr) {
      // listen for `progress` event
      xhr.onprogress = event => {
        // event.loaded returns how many bytes are downloaded
        // event.total returns the total number of bytes
        // event.total is only available if server sends `Content-Length` header
        console.log(`Downloaded ${event.loaded} of ${event.total} bytes`)
      }
      xhr.onload = () => {
        this.saveData = false
      }
      // this.addListeners(xhr)
      xhr.open('GET', 'https://www.watcheezy.net/public/ibm/set_node.php?botWorkspace=' + this.botWorkspace + '&dialog_node=' + id + '&title=' + title )
      xhr.send()
    }
  }


  // enregistre les modifications du node déplacé
  moveNode(nodeToMove: any, newPArent: string) {
    this.saveData = true
    // mise à jour de watson et la bdd
    // console.log('moveNode --> this.botWorkspace', this.botWorkspace)
    let xhr = new XMLHttpRequest()
    if (xhr) {
      let vwParams = 'botWorkspace=' + this.botWorkspace + '&tomove=' + nodeToMove.dialog_node + '&newparent=' + newPArent + '&previousName=' + nodeToMove.conditionsLabel
      // listen for `progress` event
      xhr.onprogress = event => {
        // event.loaded returns how many bytes are downloaded
        // event.total returns the total number of bytes
        // event.total is only available if server sends `Content-Length` header
        // console.log('event', event)
        console.log(`Downloaded ${event.loaded} of ${event.total} bytes`)
      }
      xhr.onload = () => {
        //let xhr = new XMLHttpRequest()
        //if (xhr) {
            //xhr.onload = function () {
              if (xhr.responseText && xhr.responseText !== '') {
                this.$emit('changeBot')
                // console.log('move ok')
                this.saveData = false
                this.openSnackBars(true, 'Le déplacement de la branche a bien été enregistrées', 'success')
                // this.mmdata = JSON.parse(xhr.responseText)
              } else {
                this.openSnackBars(true, 'Un problème est survenu lors de l\'enregistrement.', 'error')
              }
            //}
            //xhr.open('GET', 'https://www.watcheezy.net/public/ibm/get_nodes.php?botWorkspace=' + this.botWorkspace)
            //xhr.send()
        //}
      }
      // this.addListeners(xhr)
      xhr.open('POST', 'https://www.watcheezy.net/public/ibm/move_node.php')
      xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded'); // pour le POST
      xhr.send(vwParams);
    }
  }

  warnDeleteNode(sNode:any) {
    this.showPopUpValidDel2 = true
    this.nodeToDel.title = sNode.title
    this.nodeToDel.dialog_node = sNode.dialog_node
    this.nodeToDel.id = sNode.id
  }
  confirmDeleteNodeDirect(node:any) {
    // console.log('confirmDeleteNodeDirect', node.dialog_node)
    mmdata.del(node.id) // efface le node dans mmdata
    let xhr = new XMLHttpRequest()
    if (xhr) {
      let vwParams = 'botWorkspace=' + this.botWorkspace + '&nodeToDelete=' + this.nodeToDel.dialog_node 
      // listen for `progress` event
      xhr.onprogress = event => {
        // event.loaded returns how many bytes are downloaded
        // event.total returns the total number of bytes
        // event.total is only available if server sends `Content-Length` header
        // console.log(`event ${event}`)
        console.log(`Downloaded ${event.loaded} of ${event.total} bytes`)
      }
      xhr.onload = () => {
        if(xhr.responseText && xhr.responseText !== '') {
          this.$emit('changeBot')
          let outputReturn = JSON.parse(xhr.responseText)
          mmdata.delNodeAndUpdateParent(this.nodeToDel.id, outputReturn)
          
          this.openSnackBars(true, 'La branche a bien été suprimée', 'success')
          this.editNewJumpTo = false
          this.editNewTransfert = false
          this.showPopUpOption = false
          this.newitem.label = '';
          this.branchesToDelete = []
          this.newJumpTo = []
          this.newTransfert = ''
          mmdata.resize()
          this.updateMmdata()
          // this.updateMindmap()
        }
        this.editNewOption = false
        this.editNewContentChatbot = false
        this.showPopUpValidDel2 = false
      }
      xhr.open('POST', 'https://www.watcheezy.net/public/ibm/delete_node.php')
      xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded'); // pour le POST
      xhr.send(vwParams);
    }
  }

  onChangeNodeText(data:any) {
    // console.log('onChangeNodeText', data)
    // uniquement si c'est un node de type "text"
    if (this.selectNodeInfos.output.generic[data.node].response_type === 'text') {
      this.selectNodeInfos.output.generic[data.node].values[data.nodeTypeText].text = data.content
    }
  }
  // force l'utilisateur a fermer l'editeur html avant enregistrement
  toggleCodeViewHTML(data:any) {
    this.editorToggleHTML = data.isCodeView
    // console.log('toggleCodeViewHTML', data.isCodeView)
  }

  onChangeNodeTitle(data:any) {
    // console.log('selectNodeInfos', this.selectNodeInfos)
    console.log('onChangeNodeTitle', data)
    this.selectNodeInfos.output.generic[data.node].title = data.content
  }

  onChangeOption(data:any) {
    // console.log('selectNodeInfos', this.selectNodeInfos)
    // console.log('onChangeOption', data)
    this.selectNodeInfos.output.generic[data.node].options[data.option].label = data.content
  }

  onAddOption(data:any) {
    // console.log('selectNodeInfos', this.selectNodeInfos)
    // console.log('onAddOption', data)
    this.newitem.label = data.content
  }

  saveMap() {
    this.$emit('saveMap')
  }

  async mounted() {
    this.init()
    this.mindmapSvg.on('mousedown', this.multiSelectStart)
    this.mindmapSvg.on('mousemove', this.multiSelect)
    this.mindmapSvg.on('mouseup', this.multiSelectEnd)
    this.addWatch()
    //await this.makeCenter()
    await this.fitContent()
    await this.makeZoomPlus(this.zoomable)
    await this.makeZoomMoins(this.zoomable)
    await this.makeKeyboard(this.keyboard)
    await this.makeZoom(this.zoomable)
    this.mindmapG.style('opacity', 1)
  }
}
